// Auto-generated translations - DO NOT EDIT MANUALLY
// Generated on: 2026-02-04T12:14:20.572Z
// To regenerate, run: npm run translate

export const translations = {
  en: {
    nativeName: 'English',
    langCode: 'en',

    // Navigation
    home: 'Home',
    products: 'Products',
    shipping: 'Shipping',
    myAccount: 'My Account',
    about: 'About',
    contact: 'Contact',
    legal: 'Legal provisions',
    selectLanguage: 'Language',

    // Home Page
    featuredProducts: 'Popular Products',
    exploreProducts: 'Experience',
    browseProducts: 'Browse Products',
    learnMore: 'About Us',
    shopNow: 'Shop Now',

    // Products Page
    ourProducts: 'Our Products',
    productsIntro: 'Discover our range of dairy products, made fresh in Switzerland.',
    paneerIntro: 'Discover our range of traditional and specialty Paneer products.',
    showOutOfStock: 'Show out-of-stock products',
    viewDetails: 'View Details',
    backToCart: 'Back to Cart',
    backToProducts: 'Back to Products',
    productNotFound: 'Product not found',
    benefits: 'Benefits',
    order: 'Order Now',
    addToCart: 'Add to Cart',
    soldOut: 'SOLD OUT',
    yourPrice: 'Your Price',
    youSave: 'You save:',
    productDetailOfferHint: 'Applies automatically at checkout when the offer conditions are met.',

    // Cart
    cart: 'Cart',
    cartEmpty: 'Your cart is empty',
    viewCart: 'View Cart',
    total: 'Total',
    moreItems: 'more items',
    proceedToCheckout: 'Proceed to Checkout',
    continueShopping: 'Continue Shopping',
    cartTitle: 'Shopping Cart',
    cartSubtitle: 'Review your items before checkout',
    orderSummary: 'Order Summary',
    couponDiscount: 'Coupon Discount',
    coupon: 'Coupon',
    totalCouponDiscount: 'Total Coupon Discount',
    enterCoupon: 'Enter coupon code',
    applyCoupon: 'Apply',
    couponApplied: 'Coupon applied!',
    couponAppliedWithCode: 'Coupon {code} applied',
    invalidCoupon: 'Invalid coupon',
    couponAlreadyUsed: 'You have already used this coupon',
    couponUsageLimitReached: 'This coupon has reached its usage limit',
    discountApplied: 'Discount applied: CHF',
    freeShipping: 'Free Shipping',
    freeItem: 'Free item',
    free: 'FREE',
    createdAt: 'Created',
    offerDiscount: 'Offer Discount',
    applied: 'applied',
    freeNthOrder: 'Free {item} on your {ordinal} order',
    buyXGetYFree: 'Buy {buyQty} {trigger} Get {payQty} {item} Free',
    offerBadgePercent: '{pct}% OFF',
    offerBadgeFixed: 'CHF {amount} OFF',
    cartFreeItemsBannerTitle: 'Free items with your order',
    cartFreeItemsBannerNote: 'Will be added to your order at checkout — nothing to do.',
    cartAvailableOffers: 'Available offers',
    cartAvailableOffersSubtitle: 'Unlock these offers with your order',
    loginRequired: 'Please log in to view your cart',

    // Orders
    processingOrder: 'Processing your order...',
    orderConfirmationFailed: 'Order Confirmation Failed',
    orderConfirmationFailedText: "We couldn't confirm your order. Please contact support.",
    contactSupport: 'Contact Support',
    orderConfirmed: 'Order Confirmed!',
    orderConfirmedText: 'Thank you for your order. You will receive a confirmation email shortly.',
    emailSentWithin: 'The confirmation email will be sent within the next 2 minutes.',
    invoiceSuccessText: 'Your invoice has been sent to your email. Please transfer the amount within 14 days.',
    payByCard: 'Pay by Card',
    getInvoice: 'Get Invoice',
    billMonthly: 'Bill to Monthly Account',
    acceptTerms: 'I accept the',
    termsOfService: 'Terms of Service',
    pricingAcknowledgment: 'I acknowledge that final weights for some of the items may vary due to hand-cutting. Price adjustments will be applied to my account balance accordingly.',
    marketingOptIn: 'I agree to receive new product announcements and promotions by email.',
    checkoutAgreements: 'Required agreements and communication preferences',
    volumeDiscount: 'Monthly Vol. Discount',
    accountCreditApplied: 'Account Credit Applied',
    previousBalanceDue: 'Previous Balance Due',
    monthlySpendPromo: "You've spent CHF {spend} this month! Spend CHF {remaining} more to unlock a 5% volume discount on orders!",
    creditLimitReached: "Monthly credit limit reached! Your outstanding balance (CHF {balance}) + this order exceeds your limit of CHF {limit}. Please pay via card or immediate invoice.",
    paymentMethod: 'Payment Method',
    pay: 'Pay',
    payWithWallet: 'Pay with Wallet',
    addNewCard: '+ Add New Card',
    addCard: 'Add Card',
    addingCard: 'Adding...',
    saveCardForFuture: 'Save this card for future purchases',
    loadingCards: 'Loading cards...',
    newCardAdded: 'New card added',
    remove: 'Remove',
    selectOrAddCard: 'Please select a saved card or add a new one to continue.',
    selectCardError: 'Please select or add a card to continue.',
    cardExpired: 'Card information has expired. Please re-enter your card details.',
    stripeNotReady: 'Payment system is not ready. Please refresh the page.',
    continueToPayment: 'Continue to Payment',
    fulfillmentMethod: 'Receive order via',
    deliveryMethod: 'Ship to address',
    pickUp: 'Pick from location',
    pickupFacilityDetails: 'Pickup Facility Details',
    selectValidPickupLocation: 'Select a valid pickup location...',
    selectPickupWindow: 'Select pickup window...',
    to: 'to',
    note: 'Note',
    loadingItems: 'Loading items...',
    roundingDiff: 'Rounding difference',
    totalPayable: 'Total payable',
    roundingNote: 'Totals are rounded to the nearest CHF 0.05.',
    roundingNoteMonthly: 'Totals are rounded to the nearest CHF 0.05.',
    selectPickupError: 'Please select a pickup location, date and time window.',
    choosePickupDate: 'Pick a date',
    availableTimeSlots: 'Available time slots',
    pickDateFirstHint: 'Select a date to see available time slots.',
    noPickupWindowsConfigured: 'No bookable pickup windows at this location.',
    takeOrderErrorPickupDate: 'Select a pickup date.',
    pickupSlot: 'Pickup',
    pickupBookingsUndated: 'No date (booked before the date picker)',
    pickupBookings: 'Pickup Bookings',
    pickupBookingsDescription: 'See who is coming at which pickup slot, grouped by location.',
    noPickupBookings: 'No pickup bookings yet.',
    pickupBookingsError: 'Failed to load pickup bookings.',
    pickupWindow: 'Pickup window',
    customersComing: '{count} coming',
    orderPlaced: 'Order placed',
    unknownPickupLocation: 'Unknown location',
    refresh: 'Refresh',
    status: 'Status',
    // Days of the week (for pickup windows)
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',

    deliveringTo: 'Delivering to',
    billingAddress: 'Billing Address',
    sameAsShippingAddress: 'Same as shipping address',
    addAddress: 'Add new address',
    selectAddressError: 'Please select a delivery address.',
    selectBillingAddressError: 'Please select a billing address.',
    invalidCountryEmpty: 'Delivery is currently unavailable in your area.',
    invalidCountryWithList: 'Delivery to this country is not available. We only ship to {citiesList} in Switzerland.',
    invalidCityEmpty: 'Delivery is currently unavailable in your area.',
    invalidCityWithList: 'Delivery to this city is not available. We currently deliver to: {citiesList}.',
    deliveryDisclaimerEmpty: 'Delivery is currently unavailable in your area.',
    deliveryDisclaimerWithList: 'We currently deliver to: {citiesList}.',
    deliveryNotAvailable: 'Delivery not available',
    addressSavedDeliveryUnavailable: 'Address saved. Delivery is not currently available to this address — please select a different delivery address.',

    // My Orders Page
    myOrders: 'My Orders',
    noOrdersYet: 'You have no orders yet.',
    loading: 'Loading...',
    orderNumber: "Order",
    monthlyInvoice: 'Monthly Invoice',
    downloadInvoice: 'Download Invoice',
    invoiceDownloadFailed: 'Failed to download invoice.',
    downloadDeliveryNote: 'Download Delivery Note',
    downloadCreditNote: 'Download Credit Note',
    deliveries: "Deliveries",
    deliveryNote: "Delivery Note",
    downloadNote: "Download Note",
    refundHistory: 'Refund History',
    creditNote: "Credit Note",
    orderItems: 'Order Items',
    product: 'Product',
    qty: 'Qty',
    amount: 'Amount',

    // My Orders - Filters
    searchOrders: 'Search orders...',
    allStatuses: 'All statuses',
    allPayments: 'All payments',
    noMatchingOrders: 'No orders match your filters.',

    // Order & Payment Statuses
    pending: 'Pending',
    confirmed: 'Confirmed',
    partially_shipped: 'Partially Shipped',
    shipped: 'Shipped',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    refunded: 'Refunded',
    partiallyRefunded: 'Partially Refunded',
    processed: 'Processed',
    paid: 'Paid',
    unpaid: 'Unpaid',
    overdue: 'Overdue',
    failed: 'Failed',

    // Addresses
    searchAddress: 'Type to search for an address in Switzerland...',
    fullName: 'Full name',
    companyName: 'Company Name (Optional)',
    vatNumber: 'VAT Number (Optional)',
    addressLine1: 'Address line 1',
    addressLine2: 'Address line 2',
    city: 'City',
    postalCode: 'Postal code',
    country: 'Country',
    setAsDefault: 'Set as default',
    delete: 'Delete',
    saving: 'Saving...',
    saveAddress: 'Save Address',
    cancel: 'Cancel',
    defaultAddress: 'default',
    manageAddresses: 'Manage Shipping Addresses',

    // About Page
    aboutTitle: 'Our History',
    aboutTagline: 'The journey of bringing authentic Indian dairy to Switzerland',
    aboutHeroTitle: 'Swiss Dairy Products with Indian Soul',
    aboutHeroSubtitle: 'Handcrafted Paneer, Ghee & Yogurt made fresh daily from premium Swiss milk. Experience authentic taste meets Swiss quality.',

    naturalTitle: '100% Natural',
    naturalDesc: 'Made from pure Swiss milk without any artificial additives or preservatives.',
    healthyTitle: 'Fresh Daily',
    healthyDesc: 'Handcrafted fresh every day to ensure maximum quality and authentic taste.',
    sustainableTitle: 'Swiss Quality',
    sustainableDesc: 'Premium ingredients sourced locally, combining Indian tradition with Swiss precision.',

    ourStory: 'Our Story',
    storyVision: 'Our Vision',
    storyPara1: 'Hello, I\'m Devesh. I moved to Europe over 20 years ago, and my longing for Indian cuisine has only grown since then. But my challenge to find high-quality, traditional and authentic paneer, a cheese so central to Indian cuisine, has also grown.',

    storyPara2: 'Finding Paneer in Europe was anything but easy. I\'m talking about that soft, creamy cheese treat that\'s essential in Indian dishes. For many, the only option is often to make it themselves, but this can be a time-consuming and tedious task, from the structure of the result to the laborious cleaning. I didn\'t want to compromise any longer. I wanted to be able to easily buy fresh, authentic paneer.',

    storyPara3: 'Then I met Vita, and together we decided to solve this problem once and for all. Not only for people from the Indian subcontinent, but also for Europeans and everyone else who has discovered the diversity and taste of paneer. This is how Yogi Paneer was born.',
    storyPara3Title: "Crafting Authenticity",
    storyPara3Box: "Swiss Quality",

    storyPara4: 'Since then, we have been amazed by the versatility of our paneer.',

    storyPara5: 'It is a matter close to our hearts to hear about your experiences with Yogi Paneer.',

    quoteText: 'Great food needs great ingredients',
    quoteText1: 'Handcrafted Paneer, Ghee & Yogurt made fresh daily from premium Swiss milk.',

    feedbackTitle: 'We Love Your Feedback!',
    feedbackText: 'Share your Yogi Paneer experiences with us. We\'d love to hear how you\'re enjoying our products.',

    signature: 'Devesh & Vita',
    location: 'Zug, Switzerland',

    // Product Details
    price: 'Price',
    weight: 'Weight',
    availability: 'Availability',
    inStock: 'In Stock',
    bulkOnly: 'Bulk Orders Only',
    quantity: 'QUANTITY',
    addingToCart: 'Adding...',
    addedToCart: 'Added to Cart',
    processing: 'Processing...',
    articleNumber: 'Article Number',
    variableWeightBannerTitle: 'Sold by weight',
    variableWeightBanner: 'This product is sold by weight. The final weight delivered may differ slightly from the quantity ordered. The actual price will be adjusted accordingly.',
    soldByWeightShort: 'Sold by weight',

    // Business Ordering Page
    noAddress: 'No addresses found.',
    mustAddDeliveryAddress: 'You must add a delivery address before placing an order.',
    goToSettings: 'Go to Settings',
    quickOrder: 'Quick Order',
    noItemsToAdd: 'No items to add to cart.',
    itemsAddedToCart: 'Items successfully added to cart!',
    addToCartFailed: 'Failed to add items to cart',
    quickOrderSummary: 'Quick Order Summary',
    priceInclVAT: 'Price (incl. VAT)',
    priceExclVAT: 'Price (excl. VAT)',
    cartStatus: 'Your Cart',
    itemsInCart: 'Items in cart',
    cartTotal: 'Cart total',
    checkout: 'Checkout',
    stock: 'Stock',
    outOfStock: 'Sold Out',
    stockShortfallTitle: 'Guaranteed Fresh & Crafted for You',
    stockShortfallNote: 'We make everything in small, exclusive batches to ensure the highest quality. Your order is secured for our next production run and will be shipped right after. Thank you for choosing fresh!',
    pcs: 'Pcs',
    quickOrderWeightHint: 'Weight-based products can be ordered by entering a total weight (e.g. kg); the piece count is calculated automatically and rounded up. The piece count stays editable.',
    quickOrderTableCaption: 'Quick-order variants: product, SKU, price, stock, weight, piece count and line total. Stock status is announced per row.',

    // Shipping Page
    shippingTitle: 'Shipping Information',
    shippingTagline: 'Freshness without compromise – shipping directly after production!',
    whyNotNextDay: 'Why won\'t my order be delivered the next day?',
    whyNotNextDayPara1: 'We do things differently! We value freshness and quality. When you place an order, it is a pre-order. If you place an order by Friday evening, we will take it for production and shipping next week. We do produce a little more (so we can sometimes take new orders, but we don\'t promise that).',
    whyNotNextDayPara2: 'We strive to produce the best quality and get it to you as soon as possible so you can enjoy the freshness.',
    whyNotNextDayPara3: '',
    deliveryTimeTitle: 'Delivery Timeline',
    deliveryTimeText: 'As a rule, you can expect your order to arrive within 4-7 days, but you can be sure that the goods you order will be freshly prepared (with the possible exception of ghee, which has a long shelf life).',
    deliveryTimeNote: 'Once the goods are produced, we use the post office\'s next-day priority shipping and typically ship customer orders on Tuesday/Wednesday, so they arrive the next day.',
    shippingCostsTitle: 'Shipping Costs',
    shippingCostsSubtitle: 'Shipping costs depend on the order value (includes shipping + packaging costs).',
    orderValue: 'Order Value',
    shippingCost: 'Shipping Cost',
    andAbove: 'and above',
    readyToOrder: 'Ready to Order?',
    readyToOrderText: 'Experience the freshness of authentic Swiss-made Indian dairy products delivered right to your door.',

    // Contact Page
    contactTitle: 'Contact Us',
    reachUs: 'You can reach us any time at',
    emailAddress: 'EMAIL ADDRESS',
    enterEmail: 'Enter email address',
    subscribe: 'Subscribe',
    emailLabel: 'Email',

    // Search
    searchProducts: 'Search products...',
    searchResults: 'Search Results',
    productsFound: 'products found',
    clearSearch: 'Clear Search',
    noProductsFound: 'No Products Found',
    tryDifferentSearch: 'Try searching with different keywords or browse all products.',
    viewAllProducts: 'View All Products',

    // Gallery Page
    gallery: 'Gallery',
    galleryTitle: 'Our Gallery',
    galleryTagline: 'A visual journey through the world of Yogi Foods',

    // Legal Page
    legalTitle: 'Terms and Conditions',
    legalIntro: 'These are our terms and conditions for using our website yogifoods.ch and purchasing products through the website.',
    legalContact: 'If you have any questions about these terms and conditions, please send us an email',

    termsOverview: 'General Terms',
    termsOverviewText: 'These terms and conditions, as well as any provisions or conditions in other areas of this website, together apply to the use of this website by customers. Please note that INDUB AG may make changes to this website or remove any part of the website at any time without liability to customers for such changes. INDUB AG reserves the right to change these terms and conditions in the future without expressly informing customers thereof, and continued use of the Website or placing orders after such changes will be deemed to be your consent to such changes.',

    websiteChanges: 'Website Changes',
    websiteChangesText: 'INDUB AG may make changes to this website or remove any part of the website at any time without liability to customers for such changes.',

    contractFormation: 'Contract Formation',
    contractFormationText: 'A contract between you as a customer and us will only be concluded once your order has been processed and shipped.',

    customerGuarantees: 'Customer Guarantees',
    customerGuaranteesIntro: 'If you, as a customer, place an order through this website, by placing the order you guarantee that:',
    guarantee1: 'You are not a minor or are not otherwise legally incapable of entering into a legally binding contract',
    guarantee2: 'The personal information you provide to us upon registration is complete and correct',
    guarantee3: 'You do not use a false name or the name of any other person or entity that you are not authorized to use',

    placingOrder: 'Placing an Order',
    placingOrderText: 'When you place your order, you agree to these terms and conditions. Therefore, it is important that you read these terms and conditions before proceeding and placing your order.',

    cancelOrder: 'Cancel an Order',
    cancelOrderText: 'As a customer, you may cancel an order free of charge at any time before it has entered production or been shipped. Once an order has shipped, it is no longer eligible for cancellation and is instead subject to the Right of Return policy below.',

    orderAcceptance: 'Acceptance of an Order',
    orderAcceptanceText: 'Upon acceptance of an order, you will receive an order confirmation that will be sent to your email address provided during the checkout process and will include information about the scope and prices of the order.',

    delivery: 'Delivery',
    deliveryText: 'You, as the Buyer, are free to choose between the delivery options indicated and applicable at the time. INDUB AG assumes no responsibility for any damage that occurs during transport or for any damage caused by delays that are beyond the control of INDUB AG.',

    returnRight: 'Right of Return',
    returnRightText: 'Because our products are fresh, made-to-order dairy goods, INDUB AG does not accept returns or refunds of products that have already been shipped, except where the goods are defective or do not conform to the order.',

    liability: 'Liability',
    liabilityText1: "We strive to keep the information on this website as accurate as possible, but we make no express or implied warranty as to the accuracy of the information. We also do not guarantee matters related to the use of this website, and you are responsible for ensuring that your own equipment is protected against viruses or other external factors. To the extent permitted by applicable Swiss law, INDUB AG's liability for indirect or consequential damages is excluded",
    liabilityText2: 'Your rights under applicable Swiss legislation are unaffected by the contents of this website.',

    severability: 'Severability Clause',
    severabilityText: 'In the event that any provision or condition of these Terms and Conditions is found to be invalid, illegal, or unenforceable for any reason, the provision or condition in question will be separated from the remaining Terms and Conditions that remain valid and enforceable.',

    jurisdiction: 'Governing Law and Jurisdiction',
    jurisdictionText: 'These terms and conditions, and any dispute arising from or in connection with them, are governed exclusively by Swiss law. Place of jurisdiction is Zug, Switzerland',

    // Auth
    login: 'Login',
    logout: 'Logout',
    loginTitle: 'Welcome to Yogi Foods',
    loginSubtitle: 'Sign in to access your account',
    continueWithGoogle: 'Continue with Google',
    continueWithFacebook: 'Continue with Facebook',
    loginFooter: 'By continuing, you agree to our Terms of Service and Privacy Policy.',
    authFailed: 'Authentication failed. Please try again.',
    serverError: 'Server error. Please try again later.',
    emailInUse: 'An account with this email already exists. Please log in using {provider}.',
    providerLinkedSuccess: 'We found your existing account based on your email address and logged you in automatically via {provider}.',

    // General
    pageNotFound: 'Page Not Found',
    pageNotFoundDesc: "The page you're looking for doesn't exist.",
    goHome: 'Go Home',
    error: 'Error',
    tryAgain: 'Try Again',
    adminRole: 'Admin',

    // Management Dashboard Left Panel
    commerce: 'Commerce',
    orders: 'Orders',
    invoices: 'Invoices',
    deliveryNotes: 'Delivery Notes',
    settings: 'Settings',
    pricing: 'Pricing & Products',

    // Page descriptions
    settingsDesc: 'Manage your personal details, shipping addresses, and billing preferences securely.',
    myOrdersDesc: 'Review your past orders, access delivery notes, and see active invoices related to your account.',
    invoicesDesc: 'View and manage all your invoices.',
    deliveryNotesDesc: 'View and manage all your delivery notes.',

    // Invoices Page
    noInvoicesYet: 'You have no invoices yet.',
    invoiceForOrder: 'Invoice for Order',
    date: 'Date',
    downloadPDF: 'Download PDF',

    // Delivery Notes Page
    deliveryForOrder: 'Delivery for Order',
    noDeliveryNotesYet: 'You have no delivery notes yet.',

    // Settings Page
    shippingAddresses: 'Shipping Addresses',
    billingAddresses: 'Billing Addresses',
    savedCards: 'Saved Cards',
    manageBillingAddresses: 'Manage Billing Addresses',
    saveBilling: 'Save Billing Address',
    noBillingAddresses: 'No billing addresses yet.',
    noSavedCards: 'No saved cards found.',
    paymentDisclaimer: 'Cards are securely stored by Stripe. We do not store any credit card information on our servers.',
    accountBalance: 'Account Balance',
    availableCredit: 'Available Credit',

    // General
    translationNotice: 'This content has been translated',
    detectedLanguage: 'Current Language',
    browserLanguage: 'Browser Language',
    endingIn: 'ending in',
    expires: 'Expires',
    deleting: 'Deleting...',
    saveShippingAddress: 'Save Shipping Address',
    addressLine2Optional: 'Address line 2 (optional)',
    noShippingAddresses: 'No shipping addresses yet.',
    exclVAT: 'excl. VAT',
    inclVAT: 'incl. VAT',
    excl: 'excl.',
    subtotal: 'Subtotal',
    incl: 'incl.',
    vat: 'VAT',
    default: 'Default',
    makeDefault: 'Make Default',
    noAddresses: 'No shipping addresses yet.',

    // Legal / TOS / Privacy
    tosTitle: 'Terms of Service',
    tosIntro: 'These terms and conditions govern your use of our website and services. By accessing or using our website, you agree to be bound by these terms.',
    tosFacebook: 'By logging in with Facebook, you authorize us to access your public profile and email address. We do not post anything to your Facebook account without your explicit permission.',
    tosResponsibility: 'You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.',
    privacyPolicyPageTitle: 'Privacy Policy',
    collectionOfInfo: 'Collection of Information',
    collectionDesc: 'We collect information you provide directly, such as your name, email address, and shipping address. We also automatically collect certain information about your device and browsing behavior.',
    useOfInfo: 'Use of Information',
    useDesc: 'We use the information we collect to process your orders, communicate with you, improve our services, and comply with legal obligations.',
    dataReqDeletion: 'Data Deletion Request',
    dataReqDesc: 'You can request deletion of your personal data by contacting us. We will process your request in accordance with applicable data protection laws.',
    gdprCompliance: 'GDPR Compliance',
    gdprIntro: 'We are committed to protecting your personal data and ensuring compliance with the General Data Protection Regulation (GDPR).',
    dataRights: 'Data Rights',
    rightToAccess: 'Right to Access',
    accessDesc: 'You have the right to access your personal data and obtain information about how it is processed.',
    rightToErasure: 'Right to Erasure',
    erasureDesc: 'You have the right to request the deletion of your personal data under certain conditions.',
    contactUsGdpr: 'Contact Us',
    contactGdprDesc: 'If you have any questions or concerns about your data rights or our GDPR compliance, please contact us.',
    lastUpdated: 'Last updated:',

    // Product Detail
    buyItNow: 'Buy It Now',
    contactForBulk: 'Contact for Inquiry',
    productNotFoundText: 'The product you are looking for does not exist.',

    // Shipping
    freeShippingBadge: 'Free Shipping',
    readyToOrderTitle: 'Ready to Order?',
    shippingBadge: 'Shipping',

    // Misc
    sku: 'SKU',
    galleryBadge: 'Gallery',
    contactBadge: 'Contact',
    legalBadge: 'Legal Provisions',
    highlightText: 'Whether on the grill, in salads or in classic Indian dishes – paneer is a culinary delight and a healthy alternative rich in protein and calcium.',
    noBillingAddress: 'No billing address selected. Please add a billing address.',
    addAnotherItem: 'Add Another Item',
    createOrderFor: 'Create Order for',
    creating: 'Creating...',
    placeOrderOnBehalf: 'Place Order on Behalf',
    selectOneProduct: 'Please select at least one product.',
    selectProduct: 'Select Product',
    failedLoadProducts: 'Failed to load products',

    // Admin take-order wizard
    takeOrderWizardSteps: 'Order wizard steps',
    takeOrderStep1: 'Order details',
    takeOrderStep2: 'Items, payment & delivery',
    takeOrderIntro: 'Create an order for this customer. Invoice or monthly payment only — card, TWINT and Apple/Google Pay are not available in this flow.',
    takeOrderAddToRunning: 'Add to Running Order',
    takeOrderDestinationPickup: 'pickup',
    takeOrderRunningAppend: 'This batch is added to the open running order for {destination} ({count} items already on it).',
    takeOrderRunningAppendEmpty: 'This batch is added to the open running order for {destination}.',
    takeOrderRunningCreate: 'No running order is open for {destination} yet, so this batch starts one.',
    takeOrderShowRunning: 'Show running order till now',    takeOrderDescription: 'Order description (optional)',
    takeOrderDescriptionHint: 'Shown to the customer on their order and in emails.',
    takeOrderOrderDate: 'Order date',
    takeOrderNext: 'Next',
    takeOrderTabItems: 'Items',
    takeOrderTabPayment: 'Payment',
    takeOrderTabAddress: 'Address & Fulfillment',
    takeOrderBackToDetails: 'Back to order details',
    takeOrderBack: 'Back',
    takeOrderPlaceOrder: 'Place Order',
    takeOrderErrorNoItems: 'Add at least one product or custom line.',
    takeOrderErrorAdhocName: 'Every custom line needs a description.',
    takeOrderErrorNoProduct: 'Every product line needs a product selected.',
    takeOrderErrorNegativePrice: 'A unit price cannot be negative — enter money back as a refund with a negative quantity.',
    takeOrderErrorPaymentMethod: 'Choose a payment method.',
    takeOrderErrorDueDays: 'Enter a positive number of days until payment is due.',
    takeOrderErrorPickupLocation: 'Select a pickup location.',
    takeOrderErrorPickupTime: 'Select a pickup day / time window.',
    takeOrderErrorShippingAddress: 'Select a shipping address.',
    takeOrderErrorBillingAddress: 'Select a billing address.',
    takeOrderErrorShippingCost: 'Shipping cost must be a non-negative number.',
    takeOrderErrorOrderDate: 'An order date is required.',
    takeOrderItemProduct: 'Product',
    takeOrderSearchProduct: 'Search product…',
    takeOrderNoProducts: 'No products found',
    takeOrderQty: 'Qty',
    takeOrderUnit: 'Unit',
    takeOrderUnitPrice: 'Unit price (CHF)',
    takeOrderDiscountPct: 'Discount %',
    takeOrderRemoveItem: 'Remove item',
    takeOrderRemoveShippedItem: 'Already fulfilled — cannot be removed',
    takeOrderNoItemsHint: 'No items yet. Add a product or a custom line below.',
    takeOrderAdhocName: 'Custom line description',
    takeOrderAdhocPlaceholder: 'e.g. Rush delivery surcharge',
    takeOrderLineDiscount: 'incl. discount',
    takeOrderAddProduct: 'Add product',
    takeOrderAddAdhoc: 'Add custom line',
    takeOrderItemsHint: 'Product lines draw price and VAT from the customer\'s pricing (agreed custom prices if set, otherwise catalog) and check stock. Custom lines are free-form text rows — they are never fulfilled or refunded.',
    takeOrderWeightHint: 'Weight-based products can be ordered by weight (e.g. kg) — the pack count is derived automatically and rounded up. A negative quantity is a refund: money back, with no stock or shipping.',
    takeOrderCartDiscount: 'Discount on whole order (%)',
    takeOrderCartDiscountHint: 'Applied after all other discounts.',
    takeOrderRefundQtyHint: 'Refund — money back, no stock or shipping',
    takeOrderQtyLocked: 'Quantity locked (partially/fully shipped)',
    takeOrderRefundLine: 'Refund',
    takeOrderRefundsExceedTotal: 'Refunds exceed the order total — reduce the refund or the discount on the whole order.',
    takeOrderErrorQtyWhole: 'Every line needs a whole quantity of at least 1, or a negative one for a refund.',
    takeOrderErrorRefundsExceedTotal: 'The refunds total more than the order. Reduce the refund or the discount on the whole order.',
    takeOrderErrorCreditOnly: 'An order needs at least one product line — a refund is a negative quantity on an order that has products.',
    takeOrderErrorCartDiscount: 'The discount on the whole order must be between 0 and 100 %.',
    cartDiscount: 'Cart Discount',
    takeOrderPacksEquivalent: '= {n} × {pack}',
    takeOrderPricePerPack: 'per {pack} pack',
    takeOrderPaymentMethod: 'Payment method',
    takeOrderMethodInvoice: 'Invoice',
    takeOrderMethodInvoiceDesc: 'PDF invoice with QR bill. Payment due on the due date.',
    takeOrderMethodMonthly: 'Monthly invoice',
    takeOrderMethodMonthlyDesc: 'Rolled into the customer\'s monthly aggregated invoice.',
    takeOrderMonthlyUnavailable: 'This customer is not on monthly invoicing. It will fall back to Invoice.',
    takeOrderDueInDays: 'Payment due in (days)',
    takeOrderDueInDaysHint: 'Due date = order date + this many days (default {days}).',
    issueMonthlyInvoiceTitle: 'Issue Monthly Invoice',
    billingPeriodLabel: 'Billing period',
    billingPeriodHint: 'Aggregates all unpaid monthly orders for this month into one PDF invoice and emails it.',
    issueMonthlyInvoiceConfirm: 'Confirm & Issue',
    issueMonthlyInvoiceCancel: 'Cancel',
    issueMonthlyInvoiceSuccess: 'Monthly invoice issued successfully.',
    issueMonthlyInvoiceError: 'Failed to issue invoice.',
    issueMonthlyInvoiceNone: 'No unpaid monthly orders found for this month to invoice.',
    previewInvoiceButton: 'Preview Invoice',
    previewMonthlyInvoiceModalTitle: 'Monthly Invoice Preview',
    previewOrderCount: 'Orders',
    previewSubtotal: 'Subtotal',
    previewVat: 'VAT',
    previewTotal: 'Total',
    previewShipping: 'Shipping',
    previewInvoiceId: 'Invoice ID',
    previewPdfAriaLabel: 'Invoice PDF preview',
    previewClose: 'Close',
    previewIssueButton: 'Issue Invoice',
    previewInvoiceGroupNone: 'No billing address',
    previewInvoiceGroupUnknown: 'Unknown address',
    takeOrderFulfillment: 'Fulfillment method',
    takeOrderDelivery: 'Delivery',
    takeOrderDeliveryDesc: 'Shipping address is required. Shipping cost is computed from the discounted item subtotal.',
    takeOrderPickup: 'Pickup',
    takeOrderPickupDesc: 'No shipping cost. A pickup location, date and time slot are required.',
    takeOrderPickupLocation: 'Pickup location',
    takeOrderPickupLocationPlaceholder: 'Select a location…',
    takeOrderBillingAddress: 'Billing address',
    takeOrderNoBillingPlaceholder: 'Select a billing address…',
    takeOrderNoShippingAddresses: 'This customer has no saved shipping addresses. Delivery cannot be selected until they add one.',
    takeOrderNoBillingAddresses: 'This customer has no saved billing address. Add one before placing the order.',
    takeOrderShippingAddress: 'Shipping address',
    takeOrderShippingOverride: 'Shipping cost (CHF, optional)',
    takeOrderShippingOverrideHint: 'Leave empty to auto-calculate from the discounted subtotal (currently CHF {amount}). Set 0 for free shipping.',
    takeOrderShippingPlaceholder: 'Select an address…',
    takeOrderSubtotal: 'Subtotal',
    takeOrderTotalDiscount: 'Item discounts',
    takeOrderVatRate: 'VAT',
    takeOrderVatRateNORMAL: 'Normal',
    takeOrderVatRateREDUCED: 'Reduced',
    takeOrderVatRateACCOMMODATION: 'Accommodation',
    takeOrderVatRateZERO: 'Zero rate',
    takeOrderShipping: 'Shipping',
    takeOrderFree: 'free',
    takeOrderFreeShipping: 'Free shipping',
    takeOrderVat: 'VAT (incl.)',
    takeOrderRounding: 'Rounding (5 Rappen)',
    takeOrderTotalPayable: 'Total payable',
    takeOrderBeforeRounding: 'Before rounding',
    retry: 'Retry',
    takeOrderOffers: 'Auto-applied offers',
    takeOrderOffersLoading: 'Checking offers…',
    takeOrderOffersError: 'Could not check offers.',
    takeOrderOffersNone: 'No active offers apply to these items.',
    takeOrderOffersRefresh: 'Re-check offers',
    takeOrderOffersFreeItems: 'Includes free items:',
    takeOrderOfferPercent: 'Percentage discount',
    takeOrderOfferFixed: 'Fixed discount',
    takeOrderOfferFrom: 'from',
    takeOrderOfferFreeShipping: 'Free shipping',
    takeOrderVolumeDiscount: 'Monthly volume discount',
    takeOrderCustomerPricing: 'Customer pricing',
    takeOrderCustomerPricingLoading: 'Checking customer pricing…',
    takeOrderCustomerPricingNone: 'No customer-specific pricing applies to these items.',
    takeOrderCustomerPricingApplied: 'special pricing applied',
    takeOrderCustomerPricingVolumeApplied: 'volume pricing applied',
    takeOrderInsteadOf: 'instead of',
    takeOrderSaving: 'saving',
    takeOrderAbove: 'above',
    takeOrderBelow: 'below',
    takeOrderThresholdUnitKg: 'kg',
    takeOrderThresholdUnitUnits: 'units',
    takeOrderAboveStore: 'above store price',

    // Business Upgrade
    upgradeToBusiness: 'Upgrade to Business Account',
    upgradeBenefits: 'Get access to monthly billing, dedicated support, and more benefits for your business.',
    requestUpgrade: 'Request Upgrade',
    upgradeNeedBothAddresses: 'Please add a shipping and a billing address before requesting an upgrade.',
    upgradeNeedShippingAddress: 'Please add a shipping address before requesting an upgrade.',
    upgradeNeedBillingAddress: 'Please add a billing address before requesting an upgrade.',
    upgradeStatusPending: 'You have requested to upgrade to a business account. Your request is being reviewed.',
    upgradeStatusApproved: 'Your request to upgrade to a business account has been accepted.',
    upgradeStatusRejected: 'Your request to upgrade to a business account has been rejected.',
    upgradeRejectionReason: 'Reason',
    businessUpgradeRequests: 'Business Upgrade Requests',
    businessUpgradeRequestsDesc: 'Review and manage customer requests to upgrade to business accounts.',
    customer: 'Customer',
    email: 'Email',
    requestedOn: 'Requested On',
    reason: 'Reason',
    actions: 'Actions',
    approve: 'Approve',
    reject: 'Reject',
    rejectionReasonOptional: 'Reason (optional)',
    rejectionReason: 'Rejection reason',
    confirmReject: 'Confirm',
    noRequestsFound: 'No requests found.',
    status_pending: 'Pending',
    status_approved: 'Approved',
    status_rejected: 'Rejected',

    // Email templates (admin)
    emailTemplates: 'Email Templates',
    emailTemplatesDesc: 'Manage the email templates used for transactional emails. Every workflow is matched per language, with optional per-user overrides.',
    emailTemplatesWorkflow: 'Workflow',
    emailTemplatesWorkflowNav: 'Email workflows',
    emailTemplatesGlobal: 'Global templates',
    emailTemplatesGlobalDesc: 'Fallback templates used for every customer, matched by language.',
    emailTemplatesUserOverrides: 'User-specific overrides',
    emailTemplatesUserOverridesDesc: 'Templates that win for a specific customer. Matched before the global template.',
    emailTemplatesAddGlobal: 'Add global template',
    emailTemplatesAddUser: 'Add user-specific template',
    emailTemplatesLanguage: 'Language',
    emailTemplatesSubject: 'Subject',
    emailTemplatesUpdated: 'Updated',
    emailTemplatesActions: 'Actions',
    emailTemplatesMatch: 'Match',
    emailTemplatesEdit: 'Edit',
    emailTemplatesDelete: 'Delete',
    emailTemplatesNewTitle: 'New template',
    emailTemplatesEditTitle: 'Edit template',
    emailTemplatesUser: 'User',
    emailTemplatesBody: 'Body',
    emailTemplatesTokens: 'Insert tokens',
    emailTemplatesSavedTitle: 'Template saved',
    emailTemplatesSavedNotif: 'The template is now in use.',
    emailTemplatesDeletedTitle: 'Template deleted',
    emailTemplatesConfirmDelete: 'Delete this template?',
    emailTemplatesValidationUser: 'Select a user.',
    emailTemplatesValidationSubject: 'A subject is required.',
    emailTemplatesGlobalBadge: 'Global',
    emailTemplatesUserBadge: 'User override',
    emailTemplatesNoOverrides: 'No user-specific overrides yet.',
    emailTemplatesNoLanguages: 'No languages are configured yet.',
    emailTemplatesNoUsers: 'No users found',
    emailTemplatesEditorScope: 'Scope',
    emailTemplatesGlobalCaption: 'Global templates per language for this workflow, with subject and actions',
    emailTemplatesUserCaption: 'User-specific overrides for this workflow, with user, language, subject and actions',
    emailTemplatesSubjectPlaceholder: 'Subject line — supports {{param}} tokens',
    emailTemplatesSave: 'Save template',
    emailTemplatesWorkflowLabel: 'Workflow',
    emailTemplatesBodyHint: 'Plain text — the HTML is generated automatically. {{param}} tokens are auto-escaped; {{block:name}} tokens render pre-built blocks (items, totals, addresses). Tokens a workflow does not provide render as empty text.',
    emailTemplatesBodyPlaceholder: 'Hello {{userName}},\n\nThank you for your order.\n\n{{block:itemsList}}',
    emailTemplatesSelectUser: 'Select a user…',
    emailTemplatesTestSend: 'Send test email',
    emailTemplatesTestSentTitle: 'Test email sent',
    emailTemplatesTestSentNotif: 'Test email sent to',

    // Cookies banner
    cookiesBannerTitle: 'This website uses cookies',
    cookiesBannerDesc: 'We use cookies to ensure you get the best experience on our website. You can accept all, reject non-essential cookies, or customize your preferences.',
    cookiesBannerLearnMore: 'Learn more',
    cookiesBannerCustomize: 'Customize',
    cookiesBannerRejectAll: 'Reject all',
    cookiesBannerAcceptAll: 'Accept all',
    cookiesBannerDrawerTitle: 'Cookie preferences',
    cookiesBannerPrefEssentialTitle: 'Essential',
    cookiesBannerPrefEssentialDesc: 'Required for the site to function (login, cart, security). Always on.',
    cookiesBannerPrefAnalyticsTitle: 'Analytics',
    cookiesBannerPrefAnalyticsDesc: 'Help us understand how visitors interact with the site so we can improve it.',
    cookiesBannerPrefMarketingTitle: 'Marketing',
    cookiesBannerPrefMarketingDesc: 'Used to personalize ads and measure their effectiveness across websites.',
    cookiesBannerSavePreferences: 'Save preferences',
    cookiesBannerManage: 'Manage cookie preferences',

    // Holiday
    holidayDefaultMessage: 'We are on a break — we will process your orders when we are back on {returnDate}.',
    holidayManagement: 'Holiday Management',
    holidayManagementDesc: 'Configure holiday periods when the shop is closed. A banner will be shown to customers during these dates.',
    addHoliday: 'Add Holiday',
    editHoliday: 'Edit Holiday',
    deleteHoliday: 'Delete Holiday',
    startDate: 'Start Date',
    endDate: 'End Date',
    endDateInclusive: 'Holiday includes this date — we will be back the next day.',
    messageEn: 'Message (English)',
    messageDe: 'Message (German)',
    noHolidaysConfigured: 'No holidays configured.',
    confirmDeleteHoliday: 'Delete this holiday period?',
    holidayStartEndError: 'End date must be on or after the start date.',

    // User Management (Admin)
    createUser: 'Create User',
    createUserTitle: 'Create New User',
    createUserDescription: 'Create a customer account. The user can sign in later with Google or Facebook using the same email.',
    createUserName: 'Name',
    createUserNameRequired: 'Name is required',
    createUserNamePlaceholder: 'e.g. Anna Muster',
    createUserEmail: 'Email',
    createUserEmailRequired: 'Email is required',
    createUserEmailInvalid: 'Please enter a valid email address',
    createUserEmailPlaceholder: 'anna@example.com',
    createUserCancel: 'Cancel',
    createUserSubmit: 'Create User',
    createUserClose: 'Close dialog',
    createUserDuplicateEmail: 'A user with this email already exists',
    createUserError: 'Failed to create user',
    createUserErrorTitle: 'Could not create user',
    createUserSuccess: 'User created successfully.',

    // Fulfillment
    substitutionNote: 'Free item replaced with {product} during fulfillment',

    // Running ("ongoing") monthly orders — admin
    ongoingOrderTitle: 'Running monthly order',
    ongoingBadge: 'Running',
    ongoingBadgeClosed: 'Running (closed)',
    ongoingAlreadyClosed: 'This running order has been closed. It is ready for the monthly invoice and can no longer be changed.',
    ongoingOrderId: 'Order',
    ongoingItemsCount: 'Lines',
    ongoingShipProgress: 'Shipped',
    ongoingSelectProduct: 'Select a product on this order…',
    ongoingNoProductsOnOrder: 'No products on this order yet',
    ongoingNegativeQuantity: 'Quantity to give back',
    ongoingNegativeQuantityHint: 'Enter a positive number of pieces.',
    ongoingOverrideAmount: 'Override amount (CHF, optional)',
    ongoingDerivedAmount: 'Derived from the order price',
    ongoingAmountRequired: 'Required — product not on this order',
    ongoingNoStockNote: 'No stock is returned — these goods were never shipped.',
    ongoingCompleteBtn: 'Complete running order',
    ongoingCompleteYes: 'Yes, complete it',
    ongoingCompleteConfirmTitle: 'Complete this running order?',
    ongoingCompleteConfirmMsg: 'This closes the running order, emails the customer, and makes it eligible for the monthly invoice. The customer is no longer emailed again, and no further batches can be added.',
    ongoingCannotCompleteEmpty: 'Add at least one item before completing.',
    ongoingCompleted: 'Running order completed',
    ongoingCompletedMsg: 'The customer has been emailed and the order can now be invoiced.',
    takeOrderAppendsToOngoing: 'This will be added to the open running monthly order for this billing address (currently CHF {total}). The running order is re-priced as a whole, so its total may differ from the batch total shown here. The customer is not emailed until the running order is completed.',
    takeOrderEditingRunning: 'You are editing the open running order. Payment method is fixed to monthly and cannot be changed.',
    refund: 'Refund',
    discount: 'Discount',
    addedAt: 'Added',
    minOrderDiscount: 'Min. Order Discount',
    close: 'Close',
    items: 'Items',
    unitPrice: 'Unit price'
  },
  de: {
    nativeName: 'Deutsch',
    langCode: 'de',

    // Navigation
    home: 'Startseite',
    products: 'Produkte',
    shipping: 'Versand',
    myAccount: 'Mein Konto',
    about: 'Über uns',
    contact: 'Kontakt',
    legal: 'Rechtliche Bestimmungen',
    selectLanguage: 'Sprache',

    // Home Page
    featuredProducts: 'Beliebte Produkte',
    exploreProducts: 'Erleben',
    learnMore: 'Über uns',
    shopNow: 'Jetzt einkaufen',

    // Products Page
    ourProducts: 'Unsere Produkte',
    productsIntro: 'Entdecken Sie unser Sortiment an Molkereiprodukten – frisch in der Schweiz hergestellt.',
    paneerIntro: 'Entdecken Sie unser Sortiment an traditionellen und speziellen Paneer-Produkten.',
    showOutOfStock: 'Nicht lieferbare Produkte anzeigen',
    viewDetails: 'Details ansehen',
    backToCart: 'Zurück zum Warenkorb',
    backToProducts: 'Zurück zu den Produkten',
    productNotFound: 'Produkt nicht gefunden',
    benefits: 'Vorteile',
    order: 'Jetzt bestellen',
    addToCart: 'In den Warenkorb',
    soldOut: 'AUSVERKAUFT',
    yourPrice: 'Ihr Preis',
    youSave: 'Sie sparen:',
    productDetailOfferHint: 'Wird automatisch an der Kasse angewendet, wenn die Angebotsbedingungen erfüllt sind.',

    // Cart
    cart: 'Warenkorb',
    cartEmpty: 'Ihr Warenkorb ist leer',
    viewCart: 'Warenkorb ansehen',
    total: 'Gesamt',
    moreItems: 'weitere Artikel',
    proceedToCheckout: 'Zur Kasse',
    continueShopping: 'Weiter einkaufen',
    cartTitle: 'Einkaufswagen',
    cartSubtitle: 'Überprüfen Sie Ihre Artikel vor der Bestellung',
    orderSummary: 'Bestellübersicht',
    couponDiscount: 'Gutscheinrabatt',
    coupon: 'Gutschein',
    totalCouponDiscount: 'Gesamter Gutscheinrabatt',
    enterCoupon: 'Gutscheincode eingeben',
    applyCoupon: 'Anwenden',
    couponApplied: 'Gutschein angewendet!',
    couponAppliedWithCode: 'Gutschein {code} angewendet',
    invalidCoupon: 'Ungültiger Gutschein',
    couponAlreadyUsed: 'Sie haben diesen Gutschein bereits verwendet',
    couponUsageLimitReached: 'Dieser Gutschein hat seine Nutzungsgrenze erreicht',
    discountApplied: 'Rabatt angewendet: CHF',
    freeShipping: 'Kostenloser Versand',
    freeItem: 'Kostenloses Produkt',
    free: 'GRATIS',
    createdAt: 'Erstellt',
    offerDiscount: 'Angebotsrabatt',
    applied: 'angewendet',
    freeNthOrder: 'Kostenloses {item} bei Ihrer {ordinal}. Bestellung',
    buyXGetYFree: 'Kaufen Sie {buyQty} {trigger}, bekommen Sie {payQty} {item} gratis',
    offerBadgePercent: '{pct}% RABATT',
    offerBadgeFixed: 'CHF {amount} RABATT',
    cartFreeItemsBannerTitle: 'Kostenlose Artikel zu Ihrer Bestellung',
    cartFreeItemsBannerNote: 'Werden an der Kasse automatisch zu Ihrer Bestellung hinzugefügt — kein Code nötig.',
    cartAvailableOffers: 'Verfügbare Angebote',
    cartAvailableOffersSubtitle: 'Entdecken Sie diese Angebote für Ihre Bestellung',
    loginRequired: 'Bitte melden Sie sich an, um Ihren Warenkorb zu sehen',

    // Orders
    processingOrder: 'Bestellung wird verarbeitet...',
    orderConfirmationFailed: 'Bestellbestätigung fehlgeschlagen',
    orderConfirmationFailedText: 'Wir konnten Ihre Bestellung nicht bestätigen. Bitte kontaktieren Sie den Support.',
    contactSupport: 'Support kontaktieren',
    orderConfirmed: 'Bestellung bestätigt!',
    orderConfirmedText: 'Vielen Dank für Ihre Bestellung. Sie erhalten in Kürze eine Bestätigungs-E-Mail.',
    emailSentWithin: 'Die Bestätigungs-E-Mail wird innerhalb der nächsten 2 Minuten versendet.',
    invoiceSuccessText: 'Ihre Rechnung wurde an Ihre E-Mail-Adresse gesendet. Bitte begleichen Sie den Betrag innerhalb von 14 Tagen.',
    payByCard: 'Mit Karte bezahlen',
    getInvoice: 'Rechnung erhalten',
    billMonthly: 'Über Monatsrechnung abrechnen',
    acceptTerms: 'Ich akzeptiere die',
    termsOfService: 'Allgemeinen Geschäftsbedingungen',
    pricingAcknowledgment: 'Ich nehme zur Kenntnis, dass das Gewicht einiger Artikel aufgrund des manuellen Zuschnitts variieren kann. Preisliche Anpassungen werden entsprechend über mein Kontoguthaben ausgeglichen.',
    marketingOptIn: 'Ich stimme zu, E-Mails mit neuen Produktankündigungen und Werbeaktionen zu erhalten.',
    checkoutAgreements: 'Erforderliche Zustimmungen und Kommunikationseinstellungen',
    volumeDiscount: 'Monatlicher Mengenrabatt',
    accountCreditApplied: 'Kontogutschrift angewendet',
    previousBalanceDue: 'Offener Saldo aus Vormonat',
    monthlySpendPromo: 'Sie haben diesen Monat bereits CHF {spend} ausgegeben! Geben Sie weitere CHF {remaining} aus, um einen Mengenrabatt von 5% auf Bestellungen freizuschalten!',
    creditLimitReached: 'Monatliches Kreditlimit erreicht! Ihr ausstehender Saldo (CHF {balance}) + diese Bestellung überschreiten Ihr Limit von CHF {limit}. Bitte zahlen Sie per Karte oder Sofortrechnung.',
    paymentMethod: 'Zahlungsmethode',
    pay: 'Bezahlen',
    payWithWallet: 'Mit Wallet bezahlen',
    addNewCard: '+ Neue Karte hinzufügen',
    addCard: 'Karte hinzufügen',
    addingCard: 'Wird hinzugefügt...',
    saveCardForFuture: 'Diese Karte für zukünftige Käufe speichern',
    loadingCards: 'Karten werden geladen...',
    newCardAdded: 'Neue Karte hinzugefügt',
    remove: 'Entfernen',
    selectOrAddCard: 'Bitte wählen Sie eine gespeicherte Karte oder fügen Sie eine neue hinzu.',
    selectCardError: 'Bitte wählen oder fügen Sie eine Karte hinzu.',
    cardExpired: 'Karteninformationen sind abgelaufen. Bitte geben Sie Ihre Kartendaten erneut ein.',
    stripeNotReady: 'Zahlungssystem ist nicht bereit. Bitte aktualisieren Sie die Seite.',
    continueToPayment: 'Zur Zahlung fortfahren',
    fulfillmentMethod: 'Empfangsart',
    deliveryMethod: 'Lieferadresse',
    pickUp: 'Abholung vor Ort',
    pickupFacilityDetails: 'Details zum Abholort',
    selectValidPickupLocation: 'Wählen Sie einen gültigen Abholort...',
    selectPickupWindow: 'Wählen Sie ein Abholfenster...',
    to: 'bis',
    note: 'Notiz',
    loadingItems: 'Artikel werden geladen...',
    roundingDiff: 'Rundungsdifferenz',
    totalPayable: 'Gesamtbetrag',
    roundingNote: 'Beträge werden auf den nächsten CHF 0.05 gerundet.',
    roundingNoteMonthly: 'Beträge werden auf den nächsten CHF 0.05 gerundet.',
    selectPickupError: 'Bitte wählen Sie Abholort, Datum und Zeitfenster.',
    choosePickupDate: 'Datum auswählen',
    availableTimeSlots: 'Verfügbare Zeitfenster',
    pickDateFirstHint: 'Wählen Sie ein Datum, um verfügbare Zeitfenster anzuzeigen.',
    noPickupWindowsConfigured: 'Keine buchbaren Abholzeitfenster an diesem Standort.',
    takeOrderErrorPickupDate: 'Wählen Sie ein Abholdatum.',
    pickupSlot: 'Abholung',
    pickupBookingsUndated: 'Ohne Datum (vor Einführung des Datumpickers gebucht)',
    pickupBookings: 'Abholbuchungen',
    pickupBookingsDescription: 'Sehen Sie, wer zu welchem Abholfenster kommt – gruppiert nach Standort.',
    noPickupBookings: 'Noch keine Abholbuchungen.',
    pickupBookingsError: 'Abholbuchungen konnten nicht geladen werden.',
    pickupWindow: 'Abholfenster',
    customersComing: '{count} angemeldet',
    orderPlaced: 'Bestellt am',
    unknownPickupLocation: 'Unbekannter Standort',
    refresh: 'Aktualisieren',
    status: 'Status',
    // Days of the week
    Monday: 'Montag',
    Tuesday: 'Dienstag',
    Wednesday: 'Mittwoch',
    Thursday: 'Donnerstag',
    Friday: 'Freitag',
    Saturday: 'Samstag',
    Sunday: 'Sonntag',

    deliveringTo: 'Lieferung an',
    billingAddress: 'Rechnungsadresse',
    sameAsShippingAddress: 'Gleich wie Lieferadresse',
    addAddress: 'Neue Adresse hinzufügen',
    selectAddressError: 'Bitte wählen Sie eine Lieferadresse.',
    selectBillingAddressError: 'Bitte wählen Sie eine Rechnungsadresse.',
    invalidCountryEmpty: 'Lieferung ist in Ihrer Region derzeit nicht verfügbar.',
    invalidCountryWithList: 'Lieferung in dieses Land ist nicht möglich. Wir versenden nur nach {citiesList} in der Schweiz.',
    invalidCityEmpty: 'Lieferung ist in Ihrer Region derzeit nicht verfügbar.',
    invalidCityWithList: 'Lieferung in diese Stadt ist nicht möglich. Wir liefern derzeit nach: {citiesList}.',
    deliveryDisclaimerEmpty: 'Lieferung ist in Ihrer Region derzeit nicht verfügbar.',
    deliveryDisclaimerWithList: 'Wir liefern derzeit nach: {citiesList}.',
    deliveryNotAvailable: 'Lieferung nicht verfügbar',
    addressSavedDeliveryUnavailable: 'Adresse gespeichert. Eine Lieferung an diese Adresse ist derzeit nicht möglich – bitte wählen Sie eine andere Lieferadresse.',

    // My Orders Page
    myOrders: 'Meine Bestellungen',
    noOrdersYet: 'Sie haben noch keine Bestellungen getätigt.',
    loading: 'Ladevorgang...',
    orderNumber: 'Bestellung',
    monthlyInvoice: 'Monatsrechnung',
    downloadInvoice: 'Rechnung herunterladen',
    invoiceDownloadFailed: 'Rechnung konnte nicht heruntergeladen werden.',
    downloadDeliveryNote: 'Lieferschein herunterladen',
    downloadCreditNote: 'Gutschrift herunterladen',
    deliveries: 'Lieferungen',
    deliveryNote: 'Lieferschein',
    downloadNote: 'Beleg herunterladen',
    refundHistory: 'Rückerstattungsverlauf',
    creditNote: 'Gutschrift',
    orderItems: 'Bestellte Artikel',
    product: 'Produkt',
    qty: 'Menge',
    amount: 'Betrag',

    // My Orders - Filters
    searchOrders: 'Bestellungen suchen...',
    allStatuses: 'Alle Status',
    allPayments: 'Alle Zahlungen',
    noMatchingOrders: 'Keine Bestellungen entsprechen Ihren Filtern.',

    // Order & Payment Statuses
    pending: 'Ausstehend',
    confirmed: 'Bestätigt',
    partially_shipped: 'Teilweise versandt',
    shipped: 'Versandt',
    delivered: 'Geliefert',
    cancelled: 'Storniert',
    refunded: 'Rückerstattet',
    partiallyRefunded: 'Teilweise rückerstattet',
    processed: 'Verarbeitet',
    paid: 'Bezahlt',
    unpaid: 'Unbezahlt',
    overdue: 'Überfällig',
    failed: 'Fehlgeschlagen',

    // Addresses
    searchAddress: 'Adresse in der Schweiz suchen...',
    fullName: 'Vollständiger Name',
    companyName: 'Firmenname (optional)',
    vatNumber: 'MWST-Nummer (optional)',
    addressLine1: 'Adresse Zeile 1',
    addressLine2: 'Adresse Zeile 2',
    city: 'Stadt',
    postalCode: 'Postleitzahl',
    country: 'Land',
    setAsDefault: 'Als Standard festlegen',
    delete: 'Löschen',
    saving: 'Speichern...',
    saveAddress: 'Adresse speichern',
    cancel: 'Abbrechen',
    defaultAddress: 'Standard',
    manageAddresses: 'Lieferadressen verwalten',

    // About Page
    aboutTitle: 'Unsere Geschichte',
    aboutTagline: 'Die Reise, authentische indische Molkereiprodukte in die Schweiz zu bringen',
    aboutHeroTitle: 'Schweizer Molkereiprodukte mit indischer Seele',
    aboutHeroSubtitle: 'Handgemachter Paneer, Ghee & Joghurt, täglich frisch hergestellt aus erstklassiger Schweizer Milch. Erleben Sie authentischen Geschmack vereint mit Schweizer Qualität.',

    naturalTitle: '100% Natürlich',
    naturalDesc: 'Hergestellt aus reiner Schweizer Milch ohne künstliche Zusätze oder Konservierungsstoffe.',
    healthyTitle: 'Täglich frisch',
    healthyDesc: 'Täglich von Hand gefertigt, um höchste Qualität und authentischen Geschmack zu gewährleisten.',
    sustainableTitle: 'Schweizer Qualität',
    sustainableDesc: 'Premium-Zutaten aus lokaler Produktion, die indische Tradition mit Schweizer Präzision verbinden.',

    ourStory: 'Unsere Geschichte',
    storyVision: 'Unsere Vision',
    storyPara1: 'Hallo, ich bin Devesh. Ich bin vor über 20 Jahren nach Europa gezogen und meine Sehnsucht nach der indischen Küche ist seitdem stetig gewachsen. Ebenso wie die Herausforderung, hochwertigen, traditionellen und authentischen Paneer zu finden – ein Käse, der so zentral für die indische Küche ist.',
    storyPara2: 'Paneer in Europa zu finden, war alles andere als einfach. Ich spreche von diesem weichen, cremigen Käse, der in indischen Gerichten unverzichtbar ist. Für viele bleibt oft nur die Option, ihn selbst herzustellen, was jedoch zeitaufwendig und mühsam ist – von der Konsistenz des Ergebnisses bis hin zum mühsamen Abwasch. Ich wollte keine Kompromisse mehr eingehen. Ich wollte die Möglichkeit haben, frischen, authentischen Paneer einfach kaufen zu können.',
    storyPara3: 'Dann traf ich Vita und gemeinsam beschlossen wir, dieses Problem ein für alle Mal zu lösen. Nicht nur für Menschen vom indischen Subkontinent, sondern auch für Europäer und alle anderen, die die Vielfalt und den Geschmack von Paneer entdeckt haben. So wurde Yogi Paneer geboren.',
    storyPara3Title: "Echtheit, mit Liebe gemacht",
    storyPara3Box: "Schweizer Qualität",
    storyPara4: 'Seitdem sind wir immer wieder begeistert von der Vielseitigkeit unseres Paneers.',
    storyPara5: 'Es liegt uns sehr am Herzen, von Ihren Erfahrungen mit Yogi Paneer zu hören.',

    quoteText: 'Gutes Essen braucht gute Zutaten',
    quoteText1: 'Handgemachter Paneer, Ghee & Joghurt, täglich frisch hergestellt aus Premium Schweizer Milch.',

    feedbackTitle: 'Wir freuen uns über Ihr Feedback!',
    feedbackText: 'Teilen Sie Ihre Yogi Paneer-Erfahrungen mit uns. Wir würden gerne erfahren, wie Ihnen unsere Produkte schmecken.',

    signature: 'Devesh & Vita',
    location: 'Zug, Schweiz',

    // Product Details
    price: 'Preis',
    weight: 'Gewicht',
    availability: 'Verfügbarkeit',
    inStock: 'Auf Lager',
    bulkOnly: 'Nur für Grossbestellungen',
    quantity: 'MENGE',
    addingToCart: 'Hinzufügen...',
    addedToCart: 'In den Warenkorb gelegt',
    processing: 'Verarbeitung...',
    articleNumber: 'Artikelnummer',
    variableWeightBannerTitle: 'Nach Gewicht verkauft',
    variableWeightBanner: 'Dieses Produkt wird nach Gewicht verkauft. Das tatsächlich gelieferte Gewicht kann geringfügig von der bestellten Menge abweichen. Der endgültige Preis wird entsprechend angepasst.',
    soldByWeightShort: 'Nach Gewicht',

    // Business Ordering
    noAddress: 'Keine Adressen gefunden.',
    mustAddDeliveryAddress: 'Sie müssen eine Lieferadresse hinzufügen, bevor Sie eine Bestellung aufgeben können.',
    goToSettings: 'Zu den Einstellungen',
    quickOrder: 'Schnellbestellung',
    noItemsToAdd: 'Keine Artikel zum Warenkorb hinzuzufügen.',
    itemsAddedToCart: 'Artikel erfolgreich zum Warenkorb hinzugefügt!',
    addToCartFailed: 'Fehler beim Hinzufügen zum Warenkorb',
    quickOrderSummary: 'Schnellbestellungs-Übersicht',
    priceInclVAT: 'Preis (inkl. MwSt.)',
    priceExclVAT: 'Preis (exkl. MwSt.)',
    cartStatus: 'Ihr Warenkorb',
    itemsInCart: 'Artikel im Warenkorb',
    cartTotal: 'Warenkorb-Gesamt',
    checkout: 'Zur Kasse',
    stock: 'Lagerbestand',
    outOfStock: 'Ausverkauft',
    stockShortfallTitle: 'Garantiert frisch & für Sie hergestellt',
    stockShortfallNote: 'Wir stellen alles in kleinen, exklusiven Chargen her, um höchste Qualität zu gewährleisten. Ihre Bestellung ist für unsere nächste Produktionsrunde gesichert und wird direkt danach versendet. Vielen Dank, dass Sie sich für Frische entschieden haben!',
    pcs: 'Stk',
    quickOrderWeightHint: 'Gewichtsbasierte Produkte können über ein Gesamtgewicht (z. B. kg) bestellt werden; die Stückzahl wird automatisch berechnet und aufgerundet. Die Stückzahl bleibt editierbar.',
    quickOrderTableCaption: 'Schnellbestellungs-Varianten: Produkt, SKU, Preis, Lagerbestand, Gewicht, Stückzahl und Zeilensumme. Der Lagerbestand wird pro Zeile angesagt.',

    // Shipping
    shippingTitle: 'Versandinformationen',
    shippingTagline: 'Frische ohne Kompromisse – Versand direkt nach der Produktion!',
    whyNotNextDay: 'Warum wird meine Bestellung nicht am nächsten Tag geliefert?',
    whyNotNextDayPara1: 'Wir machen Dinge anders! Wir legen grossen Wert auf Frische und Qualität. Wenn Sie eine Bestellung aufgeben, handelt es sich um eine Vorbestellung. Wenn Sie bis Freitagabend bestellen, produzieren wir in der Folgewoche und versenden anschliessend. Wir produzieren meist etwas mehr, um auch kurzfristige Bestellungen bedienen zu können, garantieren dies jedoch nicht.',
    whyNotNextDayPara2: 'Wir streben nach höchster Qualität und versuchen, diese so schnell wie möglich zu Ihnen zu bringen, damit Sie die Frische geniessen können.',
    whyNotNextDayPara3: '',
    deliveryTimeTitle: 'Lieferzeitplan',
    deliveryTimeText: 'In der Regel können Sie mit einer Lieferzeit von 4-7 Tagen rechnen. Sie können sicher sein, dass die Waren (mit Ausnahme von Ghee, das eine lange Haltbarkeit hat) frisch zubereitet werden.',
    deliveryTimeNote: 'Sobald die Ware produziert ist, nutzen wir den Priority-Versand der Post. Bestellungen werden typischerweise dienstags/mittwochs versandt, sodass sie am nächsten Tag eintreffen.',
    shippingCostsTitle: 'Versandkosten',
    shippingCostsSubtitle: 'Die Versandkosten hängen vom Bestellwert ab (beinhaltet Versand- und Verpackungskosten).',
    orderValue: 'Bestellwert',
    shippingCost: 'Versandkosten',
    andAbove: '    und darüber',
    readyToOrder: 'Bereit zur Bestellung?',
    readyToOrderText: 'Erleben Sie die Frische authentischer, in der Schweiz hergestellter indischer Molkereiprodukte direkt an Ihrer Haustür.',

    // Contact
    contactTitle: 'Kontaktieren Sie uns',
    reachUs: 'Sie erreichen uns jederzeit unter',
    emailAddress: 'E-MAIL-ADRESSE',
    enterEmail: 'E-Mail-Adresse eingeben',
    subscribe: 'Abonnieren',
    emailLabel: 'E-Mail',
    contactTagline: 'Haben Sie Fragen zu unserem Paneer oder Ihrer Bestellung? Wir sind gerne für Sie da.',

    // Search
    searchProducts: 'Produkte suchen...',
    searchResults: 'Suchergebnisse',
    productsFound: 'Produkte gefunden',
    clearSearch: 'Suche leeren',
    noProductsFound: 'Keine Produkte gefunden',
    tryDifferentSearch: 'Versuchen Sie es mit anderen Suchbegriffen oder durchstöbern Sie alle Produkte.',
    viewAllProducts: 'Alle Produkte anzeigen',

    // Gallery
    gallery: 'Galerie',
    galleryTitle: 'Unsere Galerie',
    galleryTagline: 'Eine visuelle Reise durch die Welt von Yogi Foods',

    // Legal
    legalTitle: 'Allgemeine Geschäftsbedingungen',
    legalIntro: 'Dies sind unsere Allgemeinen Geschäftsbedingungen für die Nutzung unserer Website yogifoods.ch und den Kauf von Produkten über die Website.',
    legalContact: 'Wenn Sie Fragen zu diesen Allgemeinen Geschäftsbedingungen haben, senden Sie uns bitte eine E-Mail.',

    termsOverview: 'Allgemeine Bestimmungen',
    termsOverviewText: 'Diese Bedingungen gelten für die Nutzung dieser Website durch Kunden. Bitte beachten Sie, dass die INDUB AG Änderungen an dieser Website vornehmen oder Teile der Website jederzeit ohne Haftung gegenüber Kunden entfernen kann. Die INDUB AG behält sich das Recht vor, diese Bedingungen zukünftig ohne ausdrückliche Mitteilung an die Kunden zu ändern. Die fortgesetzte Nutzung der Website oder das Aufgeben von Bestellungen nach solchen Änderungen gilt als Zustimmung zu diesen Änderungen.',

    websiteChanges: 'Änderungen an der Website',
    websiteChangesText: 'Die INDUB AG kann jederzeit Änderungen an dieser Website vornehmen oder Teile der Website entfernen, ohne gegenüber Kunden für solche Änderungen zu haften.',

    contractFormation: 'Vertragsschluss',
    contractFormationText: 'Ein Vertrag zwischen Ihnen als Kunde und uns kommt erst zustande, sobald Ihre Bestellung verarbeitet und versandt wurde.',

    customerGuarantees: 'Kundengarantien',
    customerGuaranteesIntro: 'Wenn Sie als Kunde eine Bestellung über diese Website aufgeben, garantieren Sie mit der Bestellung, dass:',
    guarantee1: 'Sie nicht minderjährig sind oder anderweitig rechtlich nicht in der Lage sind, einen rechtsverbindlichen Vertrag einzugehen.',
    guarantee2: 'Die persönlichen Daten, die Sie uns bei der Registrierung zur Verfügung stellen, vollständig und korrekt sind.',
    guarantee3: 'Sie keinen falschen Namen oder den Namen einer anderen Person oder Organisation verwenden, zu deren Nutzung Sie nicht berechtigt sind.',

    placingOrder: 'Bestellvorgang',
    placingOrderText: 'Mit dem Absenden der Bestellung stimmen Sie diesen Geschäftsbedingungen zu. Es ist daher wichtig, dass Sie diese Bedingungen lesen, bevor Sie fortfahren und Ihre Bestellung aufgeben.',

    cancelOrder: 'Bestellung stornieren',
    cancelOrderText: 'Als Kunde können Sie eine Bestellung jederzeit kostenlos stornieren, solange diese noch nicht in Produktion gegangen oder versandt wurde. Sobald eine Bestellung versandt wurde, ist eine Stornierung nicht mehr möglich; in diesem Fall gilt die nachstehende Rückgaberecht-Regelung.',

    orderAcceptance: 'Auftragsannahme',
    orderAcceptanceText: 'Nach Annahme einer Bestellung erhalten Sie eine Auftragsbestätigung an die von Ihnen während des Bezahlvorgangs angegebene E-Mail-Adresse, die Informationen über Umfang und Preise der Bestellung enthält.',

    delivery: 'Lieferung',
    deliveryText: 'Sie als Käufer können zwischen den zum Zeitpunkt der Bestellung verfügbaren Lieferoptionen wählen. Die INDUB AG übernimmt keine Verantwortung für Transportschäden oder Schäden, die durch Verzögerungen entstehen, welche ausserhalb der Kontrolle der INDUB AG liegen.',

    returnRight: 'Rückgaberecht',
    returnRightText: 'Da es sich bei unseren Produkten um frische, auf Bestellung hergestellte Molkereiprodukte handelt, akzeptiert die INDUB AG keine Rücksendungen oder Rückerstattungen von Produkten, die bereits versandt wurden, ausser wenn die Ware mangelhaft ist oder nicht der Bestellung entspricht.',

    liability: 'Haftung',
    liabilityText1: 'Wir bemühen uns, die Informationen auf dieser Website so genau wie möglich zu halten, geben jedoch keine ausdrückliche oder stillschweigende Garantie für die Richtigkeit der Informationen. Wir übernehmen keine Gewährleistung für Angelegenheiten im Zusammenhang mit der Nutzung dieser Website; Sie sind dafür verantwortlich, sicherzustellen, dass Ihre eigene Ausrüstung gegen Viren oder andere externe Faktoren geschützt ist. Soweit nach anwendbarem Schweizer Recht zulässig, ist die Haftung der INDUB AG für indirekte Schäden oder Folgeschäden ausgeschlossen.',
    liabilityText2: 'Ihre Rechte gemäss dem anwendbaren Schweizer Recht bleiben von den Inhalten dieser Website unberührt.',

    severability: 'Salvatorische Klausel',
    severabilityText: 'Sollte eine Bestimmung dieser Geschäftsbedingungen aus irgendeinem Grund für ungültig, rechtswidrig oder nicht durchsetzbar befunden werden, so wird diese Bestimmung von den übrigen Bedingungen getrennt, die weiterhin gültig und durchsetzbar bleiben.',

    jurisdiction: 'Anwendbares Recht und Gerichtsstand',
    jurisdictionText: 'Diese Allgemeinen Geschäftsbedingungen sowie sämtliche daraus oder im Zusammenhang damit entstehenden Streitigkeiten unterliegen ausschliesslich Schweizer Recht. Gerichtsstand ist Zug, Schweiz.',
    
    // Auth
    login: 'Anmelden',
    logout: 'Abmelden',
    loginTitle: 'Willkommen bei Yogi Foods',
    loginSubtitle: 'Melden Sie sich an, um auf Ihr Konto zuzugreifen',
    continueWithGoogle: 'Mit Google fortfahren',
    continueWithFacebook: 'Mit Facebook fortfahren',
    loginFooter: 'Durch das Fortfahren stimmen Sie unseren Nutzungsbedingungen und Datenschutzrichtlinien zu.',
    authFailed: 'Authentifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    serverError: 'Serverfehler. Bitte versuchen Sie es später noch einmal.',
    emailInUse: 'Ein Konto mit dieser E-Mail-Adresse existiert bereits. Bitte melden Sie sich über {provider} an.',
    providerLinkedSuccess: 'Wir haben Ihr bestehendes Konto anhand Ihrer E-Mail-Adresse gefunden und Sie automatisch über {provider} angemeldet.',

    // General
    pageNotFound: 'Seite nicht gefunden',
    pageNotFoundDesc: 'Die von Ihnen gesuchte Seite existiert nicht.',
    goHome: 'Zur Startseite',
    error: 'Fehler',
    tryAgain: 'Erneut versuchen',
    adminRole: 'Administrator',

    // Dashboard
    commerce: 'Handel',
    orders: 'Bestellungen',
    invoices: 'Rechnungen',
    deliveryNotes: 'Lieferscheine',
    settings: 'Einstellungen',
    pricing: 'Preise & Produkte',

    // Descriptions
    settingsDesc: 'Verwalten Sie Ihre persönlichen Daten, Lieferadressen und Abrechnungseinstellungen sicher.',
    myOrdersDesc: 'Überprüfen Sie Ihre vergangenen Bestellungen, rufen Sie Lieferscheine ab und sehen Sie offene Rechnungen zu Ihrem Konto.',
    invoicesDesc: 'Alle Ihre Rechnungen anzeigen und verwalten.',
    deliveryNotesDesc: 'Alle Ihre Lieferscheine anzeigen und verwalten.',

    // Invoices Page
    noInvoicesYet: 'Sie haben noch keine Rechnungen.',
    invoiceForOrder: 'Rechnung für Bestellung',
    date: 'Datum',
    downloadPDF: 'PDF herunterladen',

    // Delivery Notes Page
    deliveryForOrder: 'Lieferung für Bestellung',
    noDeliveryNotesYet: 'Sie haben noch keine Lieferscheine.',

    // Settings
    shippingAddresses: 'Lieferadressen',
    billingAddresses: 'Rechnungsadressen',
    savedCards: 'Gespeicherte Karten',
    manageBillingAddresses: 'Rechnungsadressen verwalten',
    saveBilling: 'Rechnungsadresse speichern',
    noBillingAddresses: 'Noch keine Rechnungsadressen vorhanden.',
    noSavedCards: 'Keine gespeicherten Karten gefunden.',
    paymentDisclaimer: 'Karten werden sicher bei Stripe gespeichert. Wir speichern keine Kreditkarteninformationen auf unseren Servern.',
    accountBalance: 'Kontostand',
    availableCredit: 'Verfügbares Guthaben',

    // General Misc
    translationNotice: 'Dieser Inhalt wurde übersetzt',
    detectedLanguage: 'Aktuelle Sprache',
    browserLanguage: 'Browsersprache',
    endingIn: 'endet auf',
    expires: 'Läuft ab',
    deleting: 'Wird gelöscht...',
    saveShippingAddress: 'Lieferadresse speichern',
    addressLine2Optional: 'Adresse Zeile 2 (optional)',
    noShippingAddresses: 'Noch keine Lieferadressen vorhanden.',
    exclVAT: 'exkl. MWST',
    inclVAT: 'inkl. MWST',
    excl: 'exkl.',
    subtotal: 'Zwischensumme',
    incl: 'inkl.',
    vat: 'MWST',
    default: 'Standard',
    makeDefault: 'Als Standard setzen',
    noAddresses: 'Noch keine Lieferadressen vorhanden.',

    // Legal / TOS / Privacy
    tosTitle: 'Nutzungsbedingungen',
    tosIntro: 'Diese Bedingungen regeln Ihre Nutzung unserer Website und Dienstleistungen. Durch den Zugriff auf unsere Website stimmen Sie diesen Bedingungen zu.',
    tosFacebook: 'Durch die Anmeldung mit Facebook autorisieren Sie uns, auf Ihr öffentliches Profil und Ihre E-Mail-Adresse zuzugreifen. Ohne Ihre ausdrückliche Erlaubnis posten wir nichts auf Ihrem Facebook-Konto.',
    tosResponsibility: 'Sie sind für die Vertraulichkeit Ihrer Anmeldedaten und für alle Aktivitäten unter Ihrem Konto verantwortlich.',
    privacyPolicyPageTitle: 'Datenschutzerklärung',
    collectionOfInfo: 'Datenerfassung',
    collectionDesc: 'Wir erfassen Informationen, die Sie direkt bereitstellen, wie Name, E-Mail-Adresse und Lieferadresse. Zudem erfassen wir automatisch bestimmte Daten über Ihr Gerät und Ihr Surfverhalten.',
    useOfInfo: 'Verwendung der Informationen',
    useDesc: 'Wir verwenden die erfassten Informationen, um Ihre Bestellungen abzuwickeln, mit Ihnen zu kommunizieren, unsere Dienste zu verbessern und rechtliche Verpflichtungen zu erfüllen.',
    dataReqDeletion: 'Antrag auf Datenlöschung',
    dataReqDesc: 'Sie können die Löschung Ihrer persönlichen Daten beantragen, indem Sie uns kontaktieren. Wir werden Ihren Antrag gemäss den geltenden Datenschutzgesetzen bearbeiten.',
    gdprCompliance: 'DSGVO-Konformität',
    gdprIntro: 'Wir verpflichten uns zum Schutz Ihrer persönlichen Daten und zur Einhaltung der Datenschutz-Grundverordnung (DSGVO).',
    dataRights: 'Datenrechte',
    rightToAccess: 'Recht auf Auskunft',
    accessDesc: 'Sie haben das Recht auf Auskunft über Ihre persönlichen Daten und Informationen darüber, wie diese verarbeitet werden.',
    rightToErasure: 'Recht auf Löschung',
    erasureDesc: 'Sie haben das Recht, unter bestimmten Bedingungen die Löschung Ihrer persönlichen Daten zu verlangen.',
    contactUsGdpr: 'Kontaktieren Sie uns',
    contactGdprDesc: 'Wenn Sie Fragen oder Bedenken zu Ihren Datenrechten oder unserer DSGVO-Konformität haben, kontaktieren Sie uns bitte.',
    lastUpdated: 'Zuletzt aktualisiert:',

    // Product Detail
    buyItNow: 'Jetzt kaufen',
    contactForBulk: 'Für Grossbestellung anfragen',
    productNotFoundText: 'Das von Ihnen gesuchte Produkt existiert nicht.',

    // Shipping
    freeShippingBadge: 'Kostenloser Versand',
    readyToOrderTitle: 'Bereit zur Bestellung?',
    shippingBadge: 'Versand',

    // Misc
    sku: 'SKU',
    galleryBadge: 'Galerie',
    contactBadge: 'Kontakt',
    legalBadge: 'Rechtliche Bestimmungen',
    highlightText: 'Ob auf dem Grill, in Salaten oder in klassischen indischen Gerichten – Paneer ist ein kulinarischer Genuss und eine gesunde Alternative, reich an Protein und Kalzium.',
    noBillingAddress: 'Keine Rechnungsadresse ausgewählt. Bitte fügen Sie eine Rechnungsadresse hinzu.',
    addAnotherItem: 'Weiteren Artikel hinzufügen',
    createOrderFor: 'Bestellung erstellen für',
    creating: 'Erstellen...',
    placeOrderOnBehalf: 'Bestellung im Auftrag aufgeben',
    selectOneProduct: 'Bitte wählen Sie mindestens ein Produkt aus.',
    selectProduct: 'Produkt auswählen',
    failedLoadProducts: 'Fehler beim Laden der Produkte',

    // Admin-Take-Order-Assistent
    takeOrderWizardSteps: 'Schritte des Bestellassistenten',
    takeOrderStep1: 'Bestelldetails',
    takeOrderStep2: 'Artikel, Zahlung & Lieferung',
    takeOrderIntro: 'Erstellen Sie eine Bestellung für diesen Kunden. Nur Rechnung oder monatliche Rechnungsstellung — Karte, TWINT und Apple/Google Pay sind in diesem Ablauf nicht verfügbar.',
    takeOrderAddToRunning: 'Zum Laufenden hinzufügen',
    takeOrderDestinationPickup: 'Abholung',
    takeOrderRunningAppend: 'Dieser Stapel wird der offenen laufenden Bestellung für {destination} hinzugefügt ({count} Positionen bereits darauf).',
    takeOrderRunningAppendEmpty: 'Dieser Stapel wird der offenen laufenden Bestellung für {destination} hinzugefügt.',
    takeOrderRunningCreate: 'Für {destination} ist noch keine laufende Bestellung offen, daher startet dieser Stapel eine neue.',
    takeOrderShowRunning: 'Gesamte laufende Bestellung anzeigen',    takeOrderDescription: 'Bestellbeschreibung (optional)',
    takeOrderDescriptionHint: 'Wird dem Kunden in seiner Bestellung und in E-Mails angezeigt.',
    takeOrderOrderDate: 'Bestelldatum',
    takeOrderNext: 'Weiter',
    takeOrderTabItems: 'Artikel',
    takeOrderTabPayment: 'Zahlung',
    takeOrderTabAddress: 'Adresse & Lieferung',
    takeOrderBackToDetails: 'Zurück zu den Bestelldetails',
    takeOrderBack: 'Zurück',
    takeOrderPlaceOrder: 'Bestellung aufgeben',
    takeOrderErrorNoItems: 'Fügen Sie mindestens ein Produkt oder eine benutzerdefinierte Zeile hinzu.',
    takeOrderErrorAdhocName: 'Jede benutzerdefinierte Zeile benötigt eine Beschreibung.',
    takeOrderErrorNoProduct: 'Für jede Produktzeile muss ein Produkt ausgewählt werden.',
    takeOrderErrorNegativePrice: 'Ein Stückpreis darf nicht negativ sein — geben Sie Geld zurück als Gutschrift mit negativer Menge.',
    takeOrderErrorPaymentMethod: 'Wählen Sie eine Zahlungsmethode.',
    takeOrderErrorDueDays: 'Geben Sie eine positive Anzahl Tage bis zur Fälligkeit ein.',
    takeOrderErrorPickupLocation: 'Wählen Sie einen Abholort.',
    takeOrderErrorPickupTime: 'Wählen Sie einen Abholtag / ein Zeitfenster.',
    takeOrderErrorShippingAddress: 'Wählen Sie eine Versandadresse.',
    takeOrderErrorBillingAddress: 'Wählen Sie eine Rechnungsadresse.',
    takeOrderErrorShippingCost: 'Die Versandkosten müssen eine nicht-negative Zahl sein.',
    takeOrderErrorOrderDate: 'Ein Bestelldatum ist erforderlich.',
    takeOrderItemProduct: 'Produkt',
    takeOrderSearchProduct: 'Produkt suchen…',
    takeOrderNoProducts: 'Keine Produkte gefunden',
    takeOrderQty: 'Menge',
    takeOrderUnit: 'Einheit',
    takeOrderUnitPrice: 'Stückpreis (CHF)',
    takeOrderDiscountPct: 'Rabatt %',
    takeOrderRemoveItem: 'Artikel entfernen',
    takeOrderRemoveShippedItem: 'Bereits ausgeliefert — kann nicht entfernt werden',
    takeOrderNoItemsHint: 'Noch keine Artikel. Fügen Sie unten ein Produkt oder eine benutzerdefinierte Zeile hinzu.',
    takeOrderAdhocName: 'Beschreibung der benutzerdefinierten Zeile',
    takeOrderAdhocPlaceholder: 'z. B. Expresslieferungszuschlag',
    takeOrderLineDiscount: 'inkl. Rabatt',
    takeOrderAddProduct: 'Produkt hinzufügen',
    takeOrderAddAdhoc: 'Benutzerdefinierte Zeile hinzufügen',
    takeOrderItemsHint: 'Produktzeilen übernehmen Preis und Mehrwertsteuer aus der Kundenpreisliste (vereinbarte Kundenpreise falls festgelegt, sonst Katalog) und prüfen den Lagerbestand. Benutzerdefinierte Zeilen sind Freitextzeilen — sie werden nie geliefert oder erstattet.',
    takeOrderWeightHint: 'Gewichtsbasierte Produkte können nach Gewicht bestellt werden (z. B. in kg) — die Packungsanzahl wird automatisch berechnet und aufgerundet. Eine negative Menge ist eine Rückerstattung: Geld zurück, ohne Lagerbestand und ohne Versand.',
    takeOrderCartDiscount: 'Rabatt auf die ganze Bestellung (%)',
    takeOrderCartDiscountHint: 'Wird nach allen anderen Rabatten angewendet.',
    takeOrderRefundQtyHint: 'Rückerstattung — Geld zurück, ohne Lagerbestand und Versand',
    takeOrderRefundLine: 'Rückerstattung',
    takeOrderRefundsExceedTotal: 'Die Rückerstattungen übersteigen den Totalbetrag — reduzieren Sie die Rückerstattung oder den Rabatt auf die ganze Bestellung.',
    takeOrderErrorQtyWhole: 'Jede Zeile braucht eine ganze Menge von mindestens 1 oder eine negative Menge für eine Rückerstattung.',
    takeOrderErrorRefundsExceedTotal: 'Die Rückerstattungen ergeben mehr als die Bestellung. Reduzieren Sie die Rückerstattung oder den Rabatt auf die ganze Bestellung.',
    takeOrderErrorCreditOnly: 'Eine Bestellung braucht mindestens eine Produktposition — eine Rückerstattung ist eine negative Menge auf einer Bestellung mit Produkten.',
    takeOrderErrorCartDiscount: 'Der Rabatt auf die ganze Bestellung muss zwischen 0 und 100 % liegen.',
    cartDiscount: 'Warenkorb-Rabatt',
    takeOrderPacksEquivalent: '= {n} × {pack}',
    takeOrderPricePerPack: 'pro {pack}-Packung',
    takeOrderPaymentMethod: 'Zahlungsmethode',
    takeOrderMethodInvoice: 'Rechnung',
    takeOrderMethodInvoiceDesc: 'PDF-Rechnung mit QR-Rechnung. Zahlbar am Fälligkeitsdatum.',
    takeOrderMethodMonthly: 'Monatsrechnung',
    takeOrderMethodMonthlyDesc: 'Wird in die monatliche Sammelrechnung des Kunden übernommen.',
    takeOrderMonthlyUnavailable: 'Dieser Kunde ist nicht für die monatliche Rechnungsstellung angemeldet. Es wird auf Rechnung zurückgegriffen.',
    takeOrderDueInDays: 'Fällig in (Tagen)',
    takeOrderDueInDaysHint: 'Fälligkeitsdatum = Bestelldatum + so viele Tage (Standard {days}).',
    issueMonthlyInvoiceTitle: 'Monatsrechnung erstellen',
    billingPeriodLabel: 'Abrechnungszeitraum',
    billingPeriodHint: 'Fasst alle unbezahlten monatlichen Bestellungen dieses Monats zu einer PDF-Rechnung zusammen und sendet sie per E-Mail.',
    issueMonthlyInvoiceConfirm: 'Bestätigen und ausstellen',
    issueMonthlyInvoiceCancel: 'Abbrechen',
    issueMonthlyInvoiceSuccess: 'Monatsrechnung erfolgreich ausgestellt.',
    issueMonthlyInvoiceError: 'Rechnung konnte nicht ausgestellt werden.',
    issueMonthlyInvoiceNone: 'Keine unbezahlten monatlichen Bestellungen für diesen Monat gefunden.',
    previewInvoiceButton: 'Rechnung vorschauen',
    previewMonthlyInvoiceModalTitle: 'Vorschau der Monatsrechnung',
    previewOrderCount: 'Bestellungen',
    previewSubtotal: 'Zwischensumme',
    previewVat: 'MWST',
    previewTotal: 'Total',
    previewShipping: 'Versand',
    previewInvoiceId: 'Rechnungs-Nr.',
    previewPdfAriaLabel: 'Rechnung PDF-Vorschau',
    previewClose: 'Schliessen',
    previewIssueButton: 'Rechnung ausstellen',
    previewInvoiceGroupNone: 'Keine Rechnungsadresse',
    previewInvoiceGroupUnknown: 'Unbekannte Adresse',
    takeOrderFulfillment: 'Liefermethode',
    takeOrderDelivery: 'Lieferung',
    takeOrderDeliveryDesc: 'Eine Versandadresse ist erforderlich. Die Versandkosten werden anhand der rabattierten Artikelsumme berechnet.',
    takeOrderPickup: 'Abholung',
    takeOrderPickupDesc: 'Keine Versandkosten. Abholort, Datum und Zeitfenster sind erforderlich.',
    takeOrderPickupLocation: 'Abholort',
    takeOrderPickupLocationPlaceholder: 'Ort auswählen…',
    takeOrderBillingAddress: 'Rechnungsadresse',
    takeOrderNoBillingPlaceholder: 'Rechnungsadresse auswählen…',
    takeOrderNoShippingAddresses: 'Dieser Kunde hat keine gespeicherten Versandadressen. Lieferung kann erst nach dem Hinzufügen ausgewählt werden.',
    takeOrderNoBillingAddresses: 'Dieser Kunde hat keine gespeicherte Rechnungsadresse. Fügen Sie eine hinzu, bevor Sie die Bestellung aufgeben.',
    takeOrderShippingAddress: 'Versandadresse',
    takeOrderShippingOverride: 'Versandkosten (CHF, optional)',
    takeOrderShippingOverrideHint: 'Leer lassen, um automatisch anhand der rabattierten Artikelsumme zu berechnen (aktuell CHF {amount}). 0 für kostenlosen Versand.',
    takeOrderShippingPlaceholder: 'Adresse auswählen…',
    takeOrderSubtotal: 'Zwischensumme',
    takeOrderVatRate: 'MwSt.',
    takeOrderVatRateNORMAL: 'Normal',
    takeOrderVatRateREDUCED: 'Reduziert',
    takeOrderVatRateACCOMMODATION: 'Beherbergung',
    takeOrderVatRateZERO: 'Steuerfrei',
    takeOrderTotalDiscount: 'Artikelrabatte',
    takeOrderShipping: 'Versand',
    takeOrderFree: 'kostenlos',
    takeOrderFreeShipping: 'Kostenloser Versand',
    takeOrderVat: 'MWST (inkl.)',
    takeOrderRounding: 'Rundung (5 Rappen)',
    takeOrderTotalPayable: 'Gesamtbetrag',
    takeOrderBeforeRounding: 'Vor der Rundung',
    retry: 'Erneut versuchen',
    takeOrderOffers: 'Automatisch angewendete Angebote',
    takeOrderOffersLoading: 'Angebote werden geprüft…',
    takeOrderOffersError: 'Angebote konnten nicht geprüft werden.',
    takeOrderOffersNone: 'Für diese Artikel gelten keine aktiven Angebote.',
    takeOrderOffersRefresh: 'Angebote erneut prüfen',
    takeOrderOffersFreeItems: 'Enthält Gratisartikel:',
    takeOrderOfferPercent: 'Prozentrabatt',
    takeOrderOfferFixed: 'Festbetragsrabatt',
    takeOrderOfferFrom: 'ab',
    takeOrderOfferFreeShipping: 'Kostenloser Versand',
    takeOrderVolumeDiscount: 'Monatlicher Mengenrabatt',
    takeOrderCustomerPricing: 'Kundenpreise',
    takeOrderCustomerPricingLoading: 'Kundenpreise werden geprüft…',
    takeOrderCustomerPricingNone: 'Für diese Artikel gilt keine kundenspezifische Preisgestaltung.',
    takeOrderCustomerPricingApplied: 'Sonderpreis angewendet',
    takeOrderCustomerPricingVolumeApplied: 'Mengenpreis angewendet',
    takeOrderInsteadOf: 'statt',
    takeOrderSaving: 'Ersparnis',
    takeOrderAbove: 'über',
    takeOrderBelow: 'unter',
    takeOrderThresholdUnitKg: 'kg',
    takeOrderThresholdUnitUnits: 'Einheiten',
    takeOrderAboveStore: 'über dem Ladenpreis',

    // Geschäftlicher Upgrade
    upgradeToBusiness: 'Auf Geschäftskonto upgraden',
    upgradeBenefits: 'Erhalten Sie Zugang zu monatlicher Abrechnung, persönlichem Support und weiteren Vorteilen für Ihr Unternehmen.',
    requestUpgrade: 'Upgrade anfordern',
    upgradeNeedBothAddresses: 'Bitte geben Sie eine Versand- und eine Rechnungsadresse an, bevor Sie ein Upgrade beantragen.',
    upgradeNeedShippingAddress: 'Bitte fügen Sie eine Versandadresse hinzu, bevor Sie ein Upgrade anfordern.',
    upgradeNeedBillingAddress: 'Bitte fügen Sie eine Rechnungsadresse hinzu, bevor Sie ein Upgrade anfordern.',
    upgradeStatusPending: 'Sie haben ein Upgrade auf ein Geschäftskonto angefordert. Ihre Anfrage wird überprüft.',
    upgradeStatusApproved: 'Ihre Anfrage für ein Upgrade auf ein Geschäftskonto wurde genehmigt.',
    upgradeStatusRejected: 'Ihre Anfrage für ein Upgrade auf ein Geschäftskonto wurde abgelehnt.',
    upgradeRejectionReason: 'Grund',
    businessUpgradeRequests: 'Anfragen für Geschäftskonto-Upgrade',
    businessUpgradeRequestsDesc: 'Überprüfen und verwalten Sie Kundenanfragen für Upgrades auf Geschäftskonten.',
    customer: 'Kunde',
    email: 'E-Mail',
    requestedOn: 'Angefordert am',
    reason: 'Grund',
    actions: 'Aktionen',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    rejectionReasonOptional: 'Grund (optional)',
    rejectionReason: 'Ablehnungsgrund',
    confirmReject: 'Bestätigen',
    noRequestsFound: 'Keine Anfragen gefunden.',
    status_pending: 'Ausstehend',
    status_approved: 'Genehmigt',
    status_rejected: 'Abgelehnt',

    // E-Mail-Vorlagen (Admin)
    emailTemplates: 'E-Mail-Vorlagen',
    emailTemplatesDesc: 'Verwalten Sie die E-Mail-Vorlagen für transaktionale E-Mails. Jeder Workflow wird pro Sprache zugeordnet, mit optionalen benutzerspezifischen Überschreibungen.',
    emailTemplatesWorkflow: 'Workflow',
    emailTemplatesWorkflowNav: 'E-Mail-Workflows',
    emailTemplatesGlobal: 'Globale Vorlagen',
    emailTemplatesGlobalDesc: 'Fallback-Vorlagen für alle Kunden, zugeordnet nach Sprache.',
    emailTemplatesUserOverrides: 'Benutzerspezifische Überschreibungen',
    emailTemplatesUserOverridesDesc: 'Vorlagen, die für einen bestimmten Kunden gewinnen. Sie werden vor der globalen Vorlage zugeordnet.',
    emailTemplatesAddGlobal: 'Globale Vorlage hinzufügen',
    emailTemplatesAddUser: 'Benutzerspezifische Vorlage hinzufügen',
    emailTemplatesLanguage: 'Sprache',
    emailTemplatesSubject: 'Betreff',
    emailTemplatesUpdated: 'Aktualisiert',
    emailTemplatesActions: 'Aktionen',
    emailTemplatesMatch: 'Zuordnen',
    emailTemplatesEdit: 'Bearbeiten',
    emailTemplatesDelete: 'Löschen',
    emailTemplatesNewTitle: 'Neue Vorlage',
    emailTemplatesEditTitle: 'Vorlage bearbeiten',
    emailTemplatesUser: 'Benutzer',
    emailTemplatesBody: 'Inhalt',
    emailTemplatesTokens: 'Tokens einfügen',
    emailTemplatesSavedTitle: 'Vorlage gespeichert',
    emailTemplatesSavedNotif: 'Die Vorlage ist jetzt aktiv.',
    emailTemplatesDeletedTitle: 'Vorlage gelöscht',
    emailTemplatesConfirmDelete: 'Diese Vorlage löschen?',
    emailTemplatesValidationUser: 'Wählen Sie einen Benutzer.',
    emailTemplatesValidationSubject: 'Ein Betreff ist erforderlich.',
    emailTemplatesGlobalBadge: 'Global',
    emailTemplatesUserBadge: 'Benutzer-Überschreibung',
    emailTemplatesNoOverrides: 'Noch keine benutzerspezifischen Überschreibungen.',
    emailTemplatesNoLanguages: 'Es sind noch keine Sprachen konfiguriert.',
    emailTemplatesNoUsers: 'Keine Benutzer gefunden',
    emailTemplatesEditorScope: 'Geltungsbereich',
    emailTemplatesGlobalCaption: 'Globale Vorlagen pro Sprache für diesen Workflow, mit Betreff und Aktionen',
    emailTemplatesUserCaption: 'Benutzerspezifische Überschreibungen für diesen Workflow, mit Benutzer, Sprache, Betreff und Aktionen',
    emailTemplatesSubjectPlaceholder: 'Betreffzeile — unterstützt {{param}}-Tokens',
    emailTemplatesSave: 'Vorlage speichern',
    emailTemplatesWorkflowLabel: 'Workflow',
    emailTemplatesBodyHint: 'Reiner Text — das HTML wird automatisch erzeugt. {{param}}-Tokens werden automatisch maskiert; {{block:name}}-Tokens rendern vorgefertigte Blöcke (Artikel, Summen, Adressen). Tokens, die ein Workflow nicht bereitstellt, werden als leerer Text gerendert.',
    emailTemplatesBodyPlaceholder: 'Hallo {{userName}},\n\nVielen Dank für Ihre Bestellung.\n\n{{block:itemsList}}',
    emailTemplatesSelectUser: 'Benutzer auswählen…',
    emailTemplatesTestSend: 'Test-E-Mail senden',
    emailTemplatesTestSentTitle: 'Test-E-Mail gesendet',
    emailTemplatesTestSentNotif: 'Test-E-Mail gesendet an',

    // Cookies banner
    cookiesBannerTitle: 'Diese Website verwendet Cookies',
    cookiesBannerDesc: 'Wir verwenden Cookies, um Ihnen das beste Erlebnis auf unserer Website zu bieten. Sie können alle akzeptieren, nicht essentielle Cookies ablehnen oder Ihre Einstellungen anpassen.',
    cookiesBannerLearnMore: 'Mehr erfahren',
    cookiesBannerCustomize: 'Anpassen',
    cookiesBannerRejectAll: 'Alle ablehnen',
    cookiesBannerAcceptAll: 'Alle akzeptieren',
    cookiesBannerDrawerTitle: 'Cookie-Einstellungen',
    cookiesBannerPrefEssentialTitle: 'Essenziell',
    cookiesBannerPrefEssentialDesc: 'Erforderlich für die Funktion der Website (Login, Warenkorb, Sicherheit). Immer aktiv.',
    cookiesBannerPrefAnalyticsTitle: 'Analyse',
    cookiesBannerPrefAnalyticsDesc: 'Hilft uns zu verstehen, wie Besucher mit der Website interagieren, damit wir sie verbessern können.',
    cookiesBannerPrefMarketingTitle: 'Marketing',
    cookiesBannerPrefMarketingDesc: 'Wird verwendet, um Werbung zu personalisieren und ihre Wirksamkeit über Websites hinweg zu messen.',
    cookiesBannerSavePreferences: 'Einstellungen speichern',
    cookiesBannerManage: 'Cookie-Einstellungen verwalten',

    // Holiday
    holidayDefaultMessage: 'Wir machen Pause und bearbeiten Ihre Bestellungen ab dem {returnDate}.',
    holidayManagement: 'Ferienverwaltung',
    holidayManagementDesc: 'Konfigurieren Sie Ferienzeiten, in denen der Shop geschlossen ist. Während dieser Zeit wird ein Banner für Kunden angezeigt.',
    addHoliday: 'Ferien hinzufügen',
    editHoliday: 'Ferien bearbeiten',
    deleteHoliday: 'Ferien löschen',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    endDateInclusive: 'Der Feiertag umfasst dieses Datum — wir sind am nächsten Tag zurück.',
    messageEn: 'Nachricht (Englisch)',
    messageDe: 'Nachricht (Deutsch)',
    noHolidaysConfigured: 'Keine Ferien konfiguriert.',
    confirmDeleteHoliday: 'Diesen Ferienzeitraum löschen?',
    holidayStartEndError: 'Das Enddatum muss nach dem Startdatum liegen.',

    // User Management (Admin)
    createUser: 'Benutzer erstellen',
    createUserTitle: 'Neuen Benutzer erstellen',
    createUserDescription: 'Erstellen Sie ein Kundenkonto. Der Benutzer kann sich später mit Google oder Facebook unter derselben E-Mail-Adresse anmelden.',
    createUserName: 'Name',
    createUserNameRequired: 'Name ist erforderlich',
    createUserNamePlaceholder: 'z.B. Anna Muster',
    createUserEmail: 'E-Mail',
    createUserEmailRequired: 'E-Mail ist erforderlich',
    createUserEmailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    createUserEmailPlaceholder: 'anna@example.com',
    createUserCancel: 'Abbrechen',
    createUserSubmit: 'Benutzer erstellen',
    createUserClose: 'Dialog schließen',
    createUserDuplicateEmail: 'Ein Benutzer mit dieser E-Mail-Adresse existiert bereits',
    createUserError: 'Benutzer konnte nicht erstellt werden',
    createUserErrorTitle: 'Benutzer konnte nicht erstellt werden',
    createUserSuccess: 'Benutzer erfolgreich erstellt.',

    // Fulfillment
    substitutionNote: 'Gratisartikel wurde beim Versand durch {product} ersetzt',

    // Running ("ongoing") monthly orders — admin
    ongoingOrderTitle: 'Laufende Monatsbestellung',
    ongoingBadge: 'Laufend',
    ongoingBadgeClosed: 'Laufend (abgeschlossen)',
    ongoingAlreadyClosed: 'Diese Monatsbestellung wurde abgeschlossen. Sie ist für die Monatsrechnung bereit und kann nicht mehr geändert werden.',
    ongoingOrderId: 'Bestellung',
    ongoingItemsCount: 'Positionen',
    ongoingShipProgress: 'Versendet',
    ongoingSelectProduct: 'Produkt dieser Bestellung wählen…',
    ongoingNoProductsOnOrder: 'Noch keine Produkte in dieser Bestellung',
    ongoingNegativeQuantity: 'Menge zur Rückgabe',
    ongoingNegativeQuantityHint: 'Bitte eine positive Stückzahl eingeben.',
    ongoingOverrideAmount: 'Abweichender Betrag (CHF, optional)',
    ongoingDerivedAmount: 'Wird aus dem Bestellpreis berechnet',
    ongoingAmountRequired: 'Pflichtfeld – Produkt nicht in dieser Bestellung',
    ongoingNoStockNote: 'Es wird kein Bestand zurückgegeben – diese Ware wurde nie versandt.',
    ongoingCompleteBtn: 'Monatsbestellung abschliessen',
    ongoingCompleteYes: 'Ja, abschliessen',
    ongoingCompleteConfirmTitle: 'Diese Monatsbestellung abschliessen?',
    ongoingCompleteConfirmMsg: 'Damit wird die laufende Bestellung geschlossen, der Kunde informiert und sie für die Monatsrechnung freigegeben. Der Kunde erhält danach keine weitere E-Mail und es können keine weiteren Lieferungen hinzugefügt werden.',
    ongoingCannotCompleteEmpty: 'Fügen Sie mindestens eine Position hinzu, bevor Sie abschliessen.',
    ongoingCompleted: 'Monatsbestellung abgeschlossen',
    ongoingCompletedMsg: 'Der Kunde wurde informiert und die Bestellung kann jetzt abgerechnet werden.',
    takeOrderAppendsToOngoing: 'Dies wird zur offenen laufenden Monatsbestellung für diese Rechnungsadresse hinzugefügt (aktuell CHF {total}). Die laufende Bestellung wird als Ganzes neu berechnet, daher kann ihre Summe von der hier angezeigten Liefersumme abweichen. Der Kunde wird erst beim Abschliessen der laufenden Bestellung informiert.',
    takeOrderEditingRunning: 'Sie bearbeiten die offene laufende Monatsbestellung. Die Zahlungsart ist fest auf Monatsrechnung eingestellt und kann nicht geändert werden.',
    refund: 'Gutschrift',
    discount: 'Rabatt',
    addedAt: 'Hinzugefügt',
    minOrderDiscount: 'Mindestbestellrabatt',
    close: 'Schliessen',
    items: 'Artikel',
    unitPrice: 'Stückpreis'
  }
}